/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if ('__EXCLUDE_SLDS_ICONS__' === '__INCLUDE_SLDS_ICONS__') {
  icons = {
    account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19 12.3c0-.5-.4-.7-.5-.7h-5.3c-.4 0-.5.5-.5.5v5.7H19v-5.5zm-3.6 4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.5.5-.5h.5c.2 0 .5.3.5.5v.5zm0-2.5c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.4zm2.4 2.5c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.5.5-.5h.5c.2 0 .5.3.5.5v.5zm0-2.5c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.4zm-3.6-4.1V6.9c0-.5-.4-.7-.5-.7H5.6c-.5 0-.6.5-.6.6v11h6.3v-7.1s0-.5.5-.5h1.9s.5-.3.5-.5zm-6.5 6.4c0 .2-.2.4-.5.4h-.5c-.2 0-.5-.2-.5-.4v-.5c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm0-2.5c0 .2-.2.5-.5.5h-.5c-.2 0-.5-.3-.5-.5v-.5c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm0-2.5c0 .3-.2.5-.5.5h-.5c-.2 0-.5-.2-.5-.5v-.4c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.4zm0-2.4c0 .3-.2.5-.5.5h-.5c-.2 0-.5-.2-.5-.5v-.5c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm2.6 7.4c0 .2-.2.4-.5.4h-.4c-.3 0-.5-.2-.5-.4v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm0-2.5c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm0-2.5c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.4zm0-2.4c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm2.7 0c0 .3-.3.5-.5.5H12c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.5z"
      }
    },
    address: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 4.5a5.7 5.7 0 0 0-5.7 5.8c0 3.9 4 7.5 5.3 8.5a.6.6 0 0 0 .7 0c1.3-1 5.4-4.6 5.4-8.5a5.7 5.7 0 0 0-5.7-5.8zm0 8.1a2.4 2.4 0 1 1 2.4-2.4 2.4 2.4 0 0 1-2.4 2.4z"
      }
    },
    announcement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11 17.8l-.3-.3c-.5-.3-.5-.9-.5-1.2v-.8c0-.3-.2-.5-.4-.5H8c-.3 0-.5.2-.5.5v2.3c0 .8.5 1.4 1.2 1.4h1.5c.9 0 1-.6 1-.6s.1-.5-.2-.8zm6.8-8.2V5.5c0-.7-1-.9-1.4-.4l-2.7 2.5c-.5.3-1 .5-1.5.5H7.6C6 8.1 4.8 9.5 4.8 11v.1c0 1.5 1.2 2.7 2.8 2.7h4.6c.6 0 1.1.2 1.5.6l2.7 2.6c.4.4 1.4.3 1.4-.4v-4.1c.9 0 1.4-.6 1.4-1.5 0-.8-.6-1.4-1.4-1.4z"
      }
    },
    answer_best: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": [{
        "d": "M11.9 5.2c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.2 0 .4L5 17.7c-.2.4.2.7.6.6l2.1-.8c.1 0 .3 0 .4.1 1.1.6 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7s-3.2-6.7-7.2-6.7zm3.4 5.2l-3.6 3.7c-.2.1-.3.2-.5.2s-.4-.1-.5-.2l-1.8-1.8c-.2-.2-.2-.4 0-.5l.5-.5c.1-.2.3-.2.5 0l1.3 1.3 3.1-3.2c.2-.2.4-.2.5 0l.5.5c.2.1.2.4 0 .5z"
      }, {
        "fill-opacity": ".65",
        "d": "M24 24v-9.1L14.9 24H24zm-1-3.2l-.8.7v.1l.2 1.1c0 .1-.1.1-.1.1l-.9-.5c-.1-.1-.1-.1-.1 0l-1 .5s-.1 0-.1-.1l.2-1.1v-.1l-.8-.7c0-.1 0-.2.1-.2l1-.2h.1l.4-1c0-.1.1-.1.2 0l.4 1h.1l1 .2c.1 0 .1.1.1.2z"
      }]
    },
    answer_private: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": [{
        "fill-opacity": ".65",
        "d": "M21.4 20.2c-.3 0-.5.2-.5.4v.3h.9v-.3c0-.2-.2-.4-.4-.4z"
      }, {
        "fill-opacity": ".65",
        "d": "M24 24v-9.1L14.9 24H24zm-1.2-1.6c0 .2-.2.4-.4.4h-2.1c-.2 0-.4-.2-.4-.4v-1.2c0-.2.2-.3.4-.3h.1v-.3c0-.5.4-.9 1-.9s.9.4.9.9v.3h.1c.2 0 .4.1.4.3v1.2z"
      }, {
        "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3 0 .4l-.6 2.1c-.2.4.2.7.6.6l2.1-.7c.1-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm3.5 5.2l-3.7 3.7c-.2.1-.3.2-.5.2s-.4-.1-.5-.2L9 12.4c-.1-.1-.1-.4 0-.5l.5-.5c.1-.1.4-.1.5 0l1.3 1.3 3.1-3.2c.2-.1.4-.1.6 0l.5.5c.1.2.1.4 0 .5z"
      }]
    },
    answer_public: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3.1.4l-.7 2.1c-.1.4.2.7.6.6l2.1-.7c.2-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm3.5 5.2l-3.7 3.7c-.2.1-.3.2-.5.2s-.4-.1-.5-.2L9 12.4c-.1-.1-.1-.4 0-.5l.5-.5c.1-.1.4-.1.5 0l1.3 1.3 3.1-3.2c.2-.1.4-.1.6 0l.5.5c.1.2.1.4 0 .5z"
      }
    },
    approval: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 13h-2.7c-.8 0-1.4-.7-1.4-1.5.1-2.1 1.1-2.2 1.2-3.6.1-1.4-.8-2.7-2.3-3.1-1.8-.3-3.5 1.1-3.5 2.9 0 1.6 1.1 1.6 1.2 3.8 0 .8-.6 1.5-1.4 1.5H6.2c-.8 0-1.4.6-1.4 1.4v1c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4v-1c0-.8-.6-1.4-1.4-1.4zm0 4.3H6.2c-.2 0-.4.2-.4.4v.1c0 .8.6 1.4 1.4 1.4h9.6c.8 0 1.4-.6 1.4-1.4v-.1c0-.2-.2-.4-.4-.4z"
      }
    },
    apps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 4.8H5.8c-.6 0-1 .4-1 1v1.9c0 .5.4.9 1 .9h1.9c.5 0 .9-.4.9-.9V5.8c0-.6-.4-1-.9-1zm5.3 0h-2c-.5 0-.9.4-.9 1v1.9c0 .5.4.9.9.9h2c.5 0 .9-.4.9-.9V5.8c0-.6-.4-1-.9-1zm5.2 0h-1.9c-.5 0-.9.4-.9 1v1.9c0 .5.4.9.9.9h1.9c.6 0 1-.4 1-.9V5.8c0-.6-.4-1-1-1zM7.7 10.1H5.8c-.6 0-1 .4-1 .9v2c0 .5.4.9 1 .9h1.9c.5 0 .9-.4.9-.9v-2c0-.5-.4-.9-.9-.9zm5.3 0h-2c-.5 0-.9.4-.9.9v2c0 .5.4.9.9.9h2c.5 0 .9-.4.9-.9v-2c0-.5-.4-.9-.9-.9zm5.2 0h-1.9c-.5 0-.9.4-.9.9v2c0 .5.4.9.9.9h1.9c.6 0 1-.4 1-.9v-2c0-.5-.4-.9-1-.9zM7.7 15.4H5.8c-.6 0-1 .4-1 .9v1.9c0 .6.4 1 1 1h1.9c.5 0 .9-.4.9-1v-1.9c0-.5-.4-.9-.9-.9zm5.3 0h-2c-.5 0-.9.4-.9.9v1.9c0 .6.4 1 .9 1h2c.5 0 .9-.4.9-1v-1.9c0-.5-.4-.9-.9-.9zm5.2 0h-1.9c-.5 0-.9.4-.9.9v1.9c0 .6.4 1 .9 1h1.9c.6 0 1-.4 1-1v-1.9c0-.5-.4-.9-1-.9z"
      }
    },
    apps_admin: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 5h-11C5.7 5 5 5.7 5 6.5v11c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-11c0-.8-.7-1.5-1.5-1.5zM17 17.5H7c-.3 0-.5-.2-.5-.5V7c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zm-6.2-9.6H8.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5V8.4c0-.3-.2-.5-.5-.5zm4.8 0h-2.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5V8.4c0-.3-.2-.5-.5-.5zm-4.8 4.8H8.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5v-2.4c0-.3-.2-.5-.5-.5zm4.8 0h-2.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5v-2.4c0-.3-.2-.5-.5-.5z"
      }
    },
    article: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 14.2h3.1c.3 0 .5-.3.5-.5V6.5c0-.5-.5-1-1-1H7.8c-.4 0-.6.3-.6.6v7.6c0 .2.2.5.5.5zM18.2 7v7.6c0 .6-.4 1-.9 1H6.7c-.5 0-.9-.4-.9-1V7c-.8 0-1.5.6-1.5 1.4v7.2c0 .8.7 1.4 1.5 1.4h4.5c.3 0 .5.3.5.5s.2.5.5.5h1.4c.3 0 .5-.2.5-.5s.2-.5.5-.5h4.5c.8 0 1.5-.6 1.5-1.4V8.4c0-.8-.7-1.4-1.5-1.4zm-5 7.2h3c.4 0 .6-.3.6-.6V6c0-.3-.2-.5-.5-.5h-2.6c-.5 0-1 .5-1 1v7.2c0 .2.2.5.5.5z"
      }
    },
    asset_relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 13.1V13c0-2.1-1.3-4-3.1-4.9v-.2c0-1.3-1.1-2.4-2.4-2.4S9.6 6.6 9.6 7.9v.2C7.8 9 6.5 10.9 6.5 13v.1c-1 .3-1.7 1.2-1.7 2.3 0 1.4 1 2.4 2.4 2.4.5 0 1-.1 1.4-.4.9.7 2.1 1.1 3.4 1.1s2.4-.4 3.3-1.1c.4.2.9.4 1.5.4 1.3 0 2.4-1 2.4-2.4 0-1-.7-2-1.7-2.3zm-8.2 3.4c.2-.3.3-.7.3-1.1 0-1.1-.9-2.1-2-2.3V13c0-1.6 1-3.1 2.4-3.9.4.7 1.1 1.2 2 1.2s1.6-.5 2-1.2c1.4.8 2.4 2.3 2.4 3.9v.1c-1.1.2-2 1.2-2 2.3 0 .4.1.8.3 1.1-.8.6-1.7.9-2.7.9s-1.9-.3-2.7-.9z"
      }
    },
    assigned_resource: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm3.9 5.6l-2.5 2.4c-.2.2-.4 0-.4-.3v-1.4c-1.8 0-3 1.2-3 3.1H8.1A4.8 4.8 0 0 1 13 9.3V7.8c0-.3.3-.5.4-.3l2.5 2.5a.4.4 0 0 1 0 .4zm-9.7 5h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    avatar: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8.9 0 1.8-.3 2.6-.8.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
      },
      "ellipse": {
        "cx": "12",
        "cy": "8.76",
        "rx": "3.576",
        "ry": "3.96"
      }
    },
    avatar_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "opacity": ".5",
        "path": {
          "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8s1.8-.3 2.6-.8c.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
        },
        "ellipse": {
          "cx": "12",
          "cy": "8.76",
          "rx": "3.576",
          "ry": "3.96"
        }
      }
    },
    bot: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 6.2c1.7 0 3.1 1.4 3.1 3.1v.8c-1-.1-2.1-.2-3.1-.2s-2.1.1-3.1.2v-.8c0-1.7 1.4-3.1 3.1-3.1zm5.7 9.1l.3-2.7c.7.1 1.2.7 1.2 1.3 0 .8-.7 1.4-1.5 1.4zm-11.4 0c-.8 0-1.5-.6-1.5-1.4 0-.7.5-1.2 1.2-1.3l.3 2.7zm10.3-4.5c-1.6-.2-3.1-.3-4.6-.3s-3 .1-4.5.3c-.6 0-.9.5-.9 1l.5 4.7c.1.4.4.8.8.8 1.4.2 2.8.2 4.2.2s2.7 0 4.1-.2c.4 0 .7-.4.8-.8l.5-4.7c0-.5-.4-1-.9-1zM9.3 15c-.4 0-.7-.4-.7-.9s.3-.9.7-.9.6.4.6.9-.3.9-.6.9zm4 1l-.1.1s0 .1-.1.1h-2.4l-.1-.1v-.5c0-.1 0-.2.1-.2h.1c.1 0 .1.1.1.2v.2h2v-.2c0-.1.1-.2.2-.2s.2.1.2.2v.4zm1.2-1c-.3 0-.6-.4-.6-.9s.3-.9.6-.9.7.4.7.9-.3.9-.7.9z"
      }
    },
    business_hours: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.5 8.5h.8c.2 0 .4.1.4.4v3.3c0 .1-.1.2-.1.3l-2.2 2.2c-.1.1-.3.1-.5 0l-.5-.6c-.2-.1-.2-.3 0-.5l1.8-1.8V8.9c0-.2.1-.4.3-.4zm8.8 3.3h-1.2v-.3c-.3-3.9-3.7-6.8-7.7-6.6-3.9.4-6.9 3.8-6.6 7.7.3 3.7 3.4 6.6 7.1 6.6 2 .1 3.9-.7 5.3-2.2.1-.1.2-.2.1-.4l-.6-.7c-.2-.3-.4-.2-.6 0-1.2 1.3-3 2-4.7 1.8-2.5-.3-4.8-2.6-5.1-5-.3-3.1 2-5.9 5.1-6.2s5.8 2 6.1 5.1v.2h-1.1c-.2 0-.4.2-.4.4 0 .1.1.2.1.3l1.9 2.3c.2.2.5.2.6 0l1.9-2.3c.2-.2.2-.4 0-.6 0 0-.1-.1-.2-.1z"
      }
    },
    calibration: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 11.9c-.2.1-.3.1-.5.1-.1 0-.3 0-.5-.1-.1 0-.2.1-.2.3v6.5c0 .3.2.5.5.5h.4c.3 0 .5-.2.5-.5v-6.5c0-.2-.1-.3-.2-.3zm4.8 5.1h-1c-.1-.1-.2.1-.2.2v1.5c0 .3.2.5.5.5h.4c.3 0 .5-.2.5-.5v-1.5c0-.2-.1-.3-.2-.2zm4.8-3.6h-1c-.1-.1-.2.1-.2.2v5.1c0 .3.2.5.5.5h.4c.3 0 .5-.2.5-.5v-5.1c0-.2-.1-.3-.2-.2zm-9.4-6V5.3c0-.3-.2-.5-.5-.5H7c-.3 0-.5.2-.5.5v2.1c-.6.2-1 .8-1 1.5 0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7c0-.7-.4-1.3-1-1.5zm4.8 5V5.3c0-.3-.2-.5-.5-.5h-.4c-.3 0-.5.2-.5.5v7.1c-.6.3-1 .8-1 1.5 0 1 .8 1.7 1.7 1.7s1.7-.7 1.7-1.7c0-.7-.4-1.2-1-1.5zm4.8-3.6V5.3c0-.3-.2-.5-.5-.5h-.4c-.3 0-.5.2-.5.5v3.5c-.6.3-1 .8-1 1.5 0 1 .8 1.7 1.7 1.7s1.7-.7 1.7-1.7c0-.7-.4-1.2-1-1.5z"
      }
    },
    call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 15.3l-1.4-1.2c-.5-.4-1.3-.4-1.8 0l-1.4 1c-.2.2-.5.1-.6 0L11 13l-2.1-2.4c-.2-.2-.2-.4 0-.6l1-1.4c.4-.6.3-1.3-.1-1.8L8.6 5.3c-.5-.6-1.5-.7-2.1-.1L5.2 6.5c-.3.3-.4.7-.4 1.1.1 3 1.5 5.9 3.6 8s4.9 3.4 8 3.6c.4 0 .8-.2 1-.5l1.3-1.3c.7-.5.6-1.5-.1-2.1z"
      }
    },
    call_history: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 11.5v.5H5.3v-.5h1.4zM12 5.3c-3.6 0-6.5 2.7-6.7 6.2v.3H4.2c-.3 0-.5.3-.3.5l1.8 2.2c.2.2.4.2.6 0l1.8-2.2c.2-.2 0-.5-.3-.5H6.7v-.3C7 8.8 9.2 6.7 12 6.7c3.1 0 5.6 2.7 5.2 5.9-.2 2.3-2.4 4.4-4.7 4.7-1.7.1-3.3-.5-4.4-1.7-.2-.2-.3-.3-.5 0l-.6.6c-.1.2 0 .3.1.4 1.3 1.4 3.1 2.1 5 2.1 3.4 0 6.3-2.8 6.6-6.2.3-3.9-2.8-7.2-6.7-7.2zm-.7 5c.2-.2.2-.6 0-.8l-.5-.6c-.2-.3-.7-.3-.9-.1l-.6.6c-.1.1-.2.3-.2.5.1 1.3.7 2.6 1.6 3.4s2.1 1.5 3.4 1.6c.2 0 .4 0 .5-.2l.6-.6c.2-.2.2-.7-.1-.9l-.6-.5c-.2-.2-.6-.2-.8 0l-.6.4c-.1.1-.2.1-.3 0l-1-.9-.9-1c-.1-.1-.1-.2 0-.3l.4-.6z"
      }
    },
    campaign: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 13c-3.2 0-5.8-2.6-5.8-5.8S8.8 6.2 12 6.2s5.8 2.6 5.8 5.8-2.6 5.8-5.8 5.8zm0-10.1c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3zm0 7.2c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9zm0-4.3c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.4-1.4-1.4z"
      }
    },
    campaign_members: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill-opacity": ".65",
        "d": "M24 14.9V24h-9.1l9.1-9.1zm-1.9 6.6c-.3-.1-.3-.2-.3-.4 0-.1.1-.2.2-.3.2-.2.2-.4.2-.7 0-.5-.3-.9-.8-.9s-.9.5-.9.9c0 .3.1.5.3.7.1.1.2.2.2.3s-.1.3-.4.4c-.5.2-.9.4-.9.8 0 .3.2.5.5.5h2.4c.2 0 .4-.2.4-.5 0-.4-.4-.6-.9-.8z"
      }, {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 13c-3.2 0-5.8-2.6-5.8-5.8S8.8 6.2 12 6.2s5.8 2.6 5.8 5.8-2.6 5.8-5.8 5.8zm0-10.1c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3zm0 7.2c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9zm0-4.3c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.4-1.4-1.4z"
      }]
    },
    canvas: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.7 15.8c0 .8-.1 1.7-.3 2.6 0 .2-.2.5-.5.5-1.6.2-3.3.3-4.9.3-1.6 0-3.2-.1-4.8-.3-.3 0-.6-.3-.6-.5-.2-1.4-.4-2.8-.4-4.1 0-1.4.2-2.7.4-4.1 0-.2.3-.5.5-.5 1-.1 2-.2 3-.2 0 0 .7-.1.7-.8 0-.7-1.2-1.1-1.2-2.3 0-.9.9-1.6 2.4-1.6 1.4 0 2.4.7 2.4 1.6 0 1.2-1.2 1.6-1.2 2.3-.1.7.7.8.7.8 1 0 2 .1 3 .2.2 0 .5.3.5.5.2 1 .3 1.8.3 2.7.1.3-.2.5-.5.5H17c-.3 0-.7-.2-.9-.4 0 0-.7-.6-1.3-.6-1.1-.1-2 .9-2 2s.8 2.1 1.9 2c.7 0 1.4-.7 1.4-.7.2-.1.6-.3.8-.3.1-.1.2-.1.3-.1.3.1.6.3.5.5z"
      }
    },
    carousel: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.3 9h-.6v6.5h.6a.9.9 0 0 0 .9-.9V9.9a.9.9 0 0 0-.9-.9zm-13.5.9v4.7a.9.9 0 0 0 .9.9h.6V9h-.6a.9.9 0 0 0-.9.9zM16 8.2H8a.9.9 0 0 0-.8.9v6.3a.9.9 0 0 0 .8.9h8a.9.9 0 0 0 .8-.9V9.1a.9.9 0 0 0-.8-.9zm-1.4 6.5H9.1a.3.3 0 0 1-.3-.4l1.7-3a.2.2 0 0 1 .3 0l1 1.8a.2.2 0 0 0 .4 0l.8-1.2a.2.2 0 0 1 .3 0l1.5 2.4a.2.2 0 0 1-.2.4zm-.1-3.4a.8.8 0 1 1 .7-.8.8.8 0 0 1-.7.8z"
      }
    },
    case: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7h1c.1 0 .2-.1.2-.3V6h3.4v.7c0 .2.1.3.2.3h1c.1 0 .2-.1.2-.3V6c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v.7c0 .2.1.3.2.3zm8.7 1.4H6.2c-.8 0-1.4.6-1.4 1.4v7.7c0 .8.6 1.5 1.4 1.5h11.6c.8 0 1.4-.7 1.4-1.5V9.8c0-.8-.6-1.4-1.4-1.4z"
      }
    },
    case_change_status: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zM14 13.9L11.5 17c-.1.1-.4 0-.3-.2l.6-2.2h-1.6c-.2 0-.4-.2-.3-.3l1-2.6c.1-.3.3-.4.5-.4h2c.2 0 .4.2.3.4l-1.1 1.7h1.2c.3 0 .4.4.2.5z"
      }
    },
    case_comment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zm-5.6 7.7c-.5 0-1-.1-1.5-.4h-.1l-1 .4c-.1.1-.3-.1-.2-.2l.4-1c0-.1 0-.1-.1-.1-.2-.4-.3-.9-.3-1.3 0-1.5 1.3-2.7 2.8-2.7s2.8 1.2 2.8 2.7c0 1.4-1.2 2.6-2.8 2.6z"
      }
    },
    case_email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zm-8.7 2.7h5.8c.2 0 .2.2.2.3l-3 2.7c0 .1-.1.1-.2 0l-3-2.7c-.1-.2 0-.3.2-.3zm6 4.1c0 .3-.4.7-.7.7H9.6c-.3 0-.7-.4-.7-.7v-2.7c0-.1.1-.2.2-.1l2.3 2.2c.2.1.4.2.6.2s.4-.1.6-.2l2.2-2.2c.1-.1.3 0 .3.1v2.7z"
      }
    },
    case_log_a_call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zM15 15.9l-.6.5c-.1.1-.2.2-.4.2-1.2-.1-2.4-.7-3.2-1.5-.8-.8-1.4-1.9-1.4-3.2 0-.1 0-.3.1-.4l.6-.5c.2-.3.6-.2.8 0l.5.6c.2.2.2.5 0 .7l-.4.6v.2l.9 1 .9.8c.1.1.2.1.3 0l.5-.4c.2-.1.5-.1.7 0l.6.5c.3.2.3.6.1.9z"
      }
    },
    case_milestone: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.5 8.6H6c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.5c.8 0 1.5-.6 1.5-1.4v-7.7c0-.8-.7-1.5-1.5-1.5zm-7.7 3.1v5.2c0 .3-.2.5-.4.5-.3 0-.4-.2-.4-.5v-5.2c-.2-.2-.3-.4-.3-.6 0-.3.3-.6.6-.7s.7.3.7.6v.2c0 .1 0 .3-.2.5zM15 15s-.1.1-.1.2c-1.7 1-2.6-.6-4.1-.1-.2 0-.3 0-.3-.1v-3.1c0-.1 0-.2.1-.2 1.6-.7 2.5 1 4.2 0h.2V15zM8.9 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2z"
      }
    },
    case_transcript: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zm-3.2 7.5c0 .4-.3.7-.7.7h-3.3c-.4 0-.8-.3-.8-.7v-4.6c0-.4.4-.7.8-.7h1.6c.2 0 .3.1.3.2v1.5c0 .2.2.5.5.5h1.4c.1 0 .2.1.2.2v2.9zm0-3.8c0 .1 0 .2-.1.2h-1.1c-.2 0-.4-.2-.4-.5v-1c0-.1 0-.2.1-.2h.1l1.4 1.4v.1z"
      }
    },
    channel_program_history: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.4 11.5c.2-2.6 2.4-4.6 5.1-4.6 3 0 5.4 2.6 5 5.7-.2 2.2-2.3 4.3-4.5 4.5-1.7.2-3.2-.4-4.3-1.6-.2-.2-.3-.3-.5-.1l-.6.7c-.1.1 0 .2.1.4 1.3 1.3 3 2 4.9 2 3.3 0 6.1-2.7 6.4-6 .2-3.8-2.8-7-6.5-7-3.5 0-6.3 2.7-6.5 6v.3H4.9c-.3 0-.4.3-.3.5l1.8 2.1c.1.2.4.2.5 0l1.8-2.1c.2-.2 0-.5-.3-.5H7.3l.1-.3zm5.1-2.4c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9zm2.3 2.6H14c0-.7-.2-1.3-.4-1.7.7.3 1.1 1 1.2 1.7zm-2.6-1.9v1.9h-.6c0-.9.3-1.6.6-1.9zm0 2.5v1.9c-.3-.3-.6-1-.6-1.9h.6zm.6 1.9v-1.9h.6c0 .9-.3 1.6-.6 1.9zm0-2.5V9.8c.3.3.6 1 .6 1.9h-.6zM11.4 10c-.2.5-.3 1-.4 1.7h-.7c0-.7.5-1.4 1.1-1.7zm-1.2 2.3h.8c0 .7.2 1.3.4 1.7-.6-.3-1.1-1-1.2-1.7zm3.4 1.7c.2-.5.4-1 .4-1.7h.8c-.1.7-.5 1.4-1.2 1.7z"
      }
    },
    channel_program_levels: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 11.3l-.9-.4c-.1-.1-.3-.1-.4 0l-2.6 1.3c.4-.2.8-.2 1.3-.2.7 0 1.4.2 2.1.5l.5-.2c.4-.3.4-.8 0-1zM4.8 8.9l6.5 3c.3.1.6.1.9 0l6.5-3c.4-.2.4-.7 0-.9l-6.5-3.1c-.3-.1-.6-.1-.9 0L4.8 8c-.4.2-.4.7 0 .9zm0 3.3l6.5 3.1c.1.1.3.1.5.1.3-1.2 1-2.1 1.9-2.8l-1.5.8c-.2.1-.6.1-.9 0l-5.2-2.5c-.1-.1-.2-.1-.4 0l-.9.4c-.4.2-.4.7 0 .9zm7 4.6h-.5l-5.2-2.5c-.1-.1-.3-.1-.4 0l-.9.4c-.3.2-.3.7 0 .9l6.5 3c.3.2.6.2.9 0h.2c-.4-.6-.6-1.1-.6-1.8zM16.1 13.5c-1.5 0-2.8 1.3-2.8 2.8s1.2 2.9 2.8 2.9 2.9-1.3 2.9-2.9-1.3-2.8-2.9-2.8zm2.3 2.6h-.8c0-.7-.2-1.3-.4-1.7.7.3 1.1.9 1.2 1.7zm-2.6-1.9v1.9h-.6c0-.9.3-1.6.6-1.9zm0 2.4v1.9c-.3-.3-.6-1-.6-1.9h.6zm.6 1.9v-1.9h.7c-.1.9-.4 1.6-.7 1.9zm0-2.4v-1.9c.3.2.6 1 .7 1.9h-.7zM15 14.4c-.2.4-.3 1-.4 1.7h-.7c0-.8.5-1.4 1.1-1.7zm-1.1 2.2h.7c0 .7.2 1.3.4 1.7-.6-.3-1.1-.9-1.1-1.7zm3.3 1.7c.3-.4.4-1 .4-1.7h.8c-.1.8-.5 1.4-1.2 1.7z"
      }
    },
    channel_program_members: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.7 16.3c0-1.4.7-2.6 1.7-3.4-.3-.2-.6-.3-.9-.5-1.1-.4-1.2-.8-1.2-1.2 0-.4.3-.8.6-1.1.6-.6.9-1.3.9-2.2 0-1.7-1-3.1-2.8-3.1-1.8 0-2.9 1.4-2.9 3.1 0 .9.4 1.6 1 2.2.3.3.6.7.6 1.1 0 .4-.2.8-1.2 1.2-1.5.7-2.9 1.4-2.9 2.7 0 .9.7 1.7 1.5 1.7H11.7v-.5zm4.4-2.8c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.8 2.9 2.8 2.8-1.2 2.8-2.8-1.2-2.9-2.8-2.9zm2.3 2.6h-.8c0-.7-.2-1.3-.4-1.7.6.3 1.1 1 1.2 1.7zm-2.6-1.9v1.9h-.6c0-.9.3-1.6.6-1.9zm0 2.5v1.8c-.3-.2-.6-1-.6-1.8h.6zm.6 1.8v-1.8h.6c0 .8-.3 1.5-.6 1.8zm0-2.4v-1.9c.3.3.6 1 .6 1.9h-.6zM15 14.4c-.3.4-.4 1-.4 1.7h-.8c.1-.7.6-1.4 1.2-1.7zm-1.2 2.3h.8c0 .6.2 1.2.4 1.7-.6-.4-1.1-1-1.2-1.7zm3.4 1.7c.2-.5.3-1.1.4-1.7h.7c0 .7-.5 1.3-1.1 1.7z"
      }
    },
    channel_programs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 4.8c-4 0-7.2 3.2-7.2 7.2s3.2 7.2 7.2 7.2S19 16 19 12s-3.3-7.2-7.2-7.2zm5.7 6.5h-1.9c-.1-1.7-.5-3.2-1.1-4.3 1.6.8 2.7 2.4 3 4.3zM11 6.6v4.7H9.4c.1-2.3.8-4.1 1.6-4.7zm0 6.1v4.7c-.8-.6-1.5-2.4-1.6-4.7H11zm1.5 4.7v-4.7h1.6c-.1 2.3-.8 4.1-1.6 4.7zm0-6.1V6.6c.8.6 1.5 2.4 1.6 4.7h-1.6zM9 7c-.6 1.1-1 2.6-1.1 4.3H6C6.3 9.4 7.4 7.8 9 7zm-3 5.7h1.9c.1 1.7.5 3.2 1.1 4.3-1.6-.8-2.7-2.4-3-4.3zm8.5 4.3c.6-1.1 1-2.6 1.1-4.3h1.9c-.3 1.9-1.4 3.5-3 4.3z"
      }
    },
    client: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.8 14c.8-.5 1.7-.8 2.6-.8.3 0 .5.1.8.1.1 0 .1 0 0-.1-.4-.3-1-.5-1.5-.7-1-.5-1.2-.8-1.2-1.3 0-.4.3-.8.7-1.1.6-.5.9-1.3.9-2.2 0-1.6-1-3.1-2.9-3.1-1.8 0-2.8 1.5-2.8 3.1 0 .9.3 1.7.9 2.2.4.3.7.7.7 1.1 0 .4-.2.8-1.2 1.3-1.5.6-2.9 1.3-3 2.7 0 .9.7 1.6 1.6 1.6h3.4c.2 0 .4-.2.4-.4v-1.6c.1-.3.2-.6.6-.8zm7.8 1.4c-2.3.7-4.1-1.4-6.6-.4-.1 0-.2.2-.2.4V18c0 .3.2.6.6.5 2.4-.8 4.2 1.3 6.5.4.2-.1.3-.3.3-.5v-2.5c0-.3-.3-.6-.6-.5zm-3 2.4c-.6 0-1-.4-1-1s.4-.9 1-.9.9.4.9.9-.4 1-.9 1z"
      }
    },
    cms: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.5 7.2c-.5 0-.9 0-1.3.2.5.4.9.9 1.3 1.4 1.7 0 3 1.4 3 3.1s-1.3 3-3 3c-.4 0-.8 0-1.2-.2.2-.3.4-.7.5-1 .1-.1.2-.2.2-.4.1-.4.2-.9.2-1.4 0-2.6-2.1-4.7-4.7-4.7s-4.7 2.1-4.7 4.7 2.1 4.7 4.7 4.7c.5 0 .9-.1 1.3-.2-.5-.4-.9-.9-1.3-1.5-1.7 0-3-1.3-3-3s1.3-3.1 3-3.1c.4 0 .8.1 1.2.3-.5.7-.9 1.7-.9 2.8 0 2.6 2.1 4.7 4.7 4.7s4.7-2.1 4.7-4.7-2.1-4.7-4.7-4.7z"
      }
    },
    coaching: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.3 12.7c-.3 0-.6.1-.9.4-.4.4-.4 1.2 0 1.7.3.2.6.3.9.3.3 0 .6-.1.8-.3.5-.5.5-1.2 0-1.7-.2-.3-.5-.4-.8-.4zm7.8-5.4L17.5 5c-.2-.2-.5-.3-.7-.2l-8 5c-.8.5-1.4 1.1-1.9 2.2-.4 1-.5 2.1-.2 3.1-1.1.1-1.9 1-1.9 2.1s.9 2 2 2c.9 0 1.6-.5 1.9-1.2 1.9 1.2 4.4.9 6-.7 1.5-1.5 1.8-3.6.9-5.4-.2-.7-.1-1.4.5-1.8L19 8c.2-.1.2-.4.1-.7zM6.8 17.8c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.2.6.6-.2.6-.6.6zm6.4-2c-.6.5-1.2.8-1.9.8s-1.4-.3-1.9-.8c-1-1-1-2.7 0-3.8.5-.5 1.2-.7 1.9-.7s1.3.2 1.9.7c1 1.1 1 2.8 0 3.8z"
      }
    },
    connected_apps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 5h-11C5.7 5 5 5.7 5 6.5v11c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-11c0-.8-.7-1.5-1.5-1.5zM17 17.5H7c-.3 0-.5-.2-.5-.5V7c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zm-3-6.2h-1.5L13.8 9c.2-.2 0-.6-.3-.6h-2c-.2 0-.5.2-.6.5l-1.3 3.3c-.1.2.1.5.4.5h1.5l-.7 2.6c-.1.3.2.4.4.2l3.1-3.7c.2-.2.1-.5-.3-.5z"
      }
    },
    contact: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 7H6.2c-.8 0-1.4.6-1.4 1.4v7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7c0-.8-.6-1.4-1.4-1.4zm-6.1 8.1H7.5c-.4 0-.8-.5-.8-1 0-.7.8-1.1 1.6-1.5.5-.2.6-.4.6-.7s-.1-.4-.3-.6c-.3-.3-.5-.7-.5-1.2 0-.9.5-1.7 1.5-1.7s1.5.8 1.5 1.7c0 .5-.2.9-.5 1.2-.2.2-.4.4-.4.6s.1.5.7.7c.8.3 1.5.8 1.5 1.5.1.5-.3 1-.7 1zm5.6-1.7c0 .3-.2.5-.5.5h-2.2c-.2 0-.4-.2-.4-.5v-.7c0-.2.2-.5.4-.5h2.2c.3 0 .5.3.5.5v.7zm0-2.6c0 .3-.2.5-.5.5h-3.6c-.3 0-.5-.2-.5-.5v-.7c0-.3.2-.5.5-.5h3.6c.3 0 .5.2.5.5v.7z"
      }
    },
    contact_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.3 5.4c-1.1 0-2 .9-2 1.9V18c0 1 .9 1.8 2 1.8h10.5c1.1 0 1.9-.8 1.9-1.8V7.3c0-1-.8-1.9-1.9-1.9H6.3zm2.6 4.4c0 .4-.3.6-.6.6h-.7c-.3 0-.6-.2-.6-.6v-.6c0-.3.3-.6.6-.6h.7c.3 0 .6.3.6.6v.6zm7.2 0c0 .4-.3.6-.6.6h-4.6c-.4 0-.7-.2-.7-.6v-.6c0-.3.3-.6.7-.6h4.6c.3 0 .6.3.6.6v.6zM8.9 13c0 .3-.3.6-.6.6h-.7c-.3 0-.6-.3-.6-.6v-.7c0-.3.3-.6.6-.6h.7c.3 0 .6.3.6.6v.7zm6 0c0 .3-.3.6-.6.6h-3.4c-.4 0-.7-.3-.7-.6v-.7c0-.3.3-.6.7-.6h3.4c.3 0 .6.3.6.6v.7zm-6 3.1c0 .3-.3.6-.6.6h-.7c-.3 0-.6-.3-.6-.6v-.6c0-.4.3-.7.6-.7h.7c.3 0 .6.3.6.7v.6zm7.2 0c0 .3-.3.6-.6.6h-4.6c-.4 0-.7-.3-.7-.6v-.6c0-.4.3-.7.7-.7h4.6c.3 0 .6.3.6.7v.6z"
      }
    },
    contract: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.9 8.1l-3.2-3.2c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.6c0 .5.4.9.9.9h2.6c.2 0 .3-.1.3-.3 0-.1 0-.2-.1-.2zm-.4 2h-3.3c-.8 0-1.5-.7-1.5-1.5V5.3c0-.3-.2-.5-.5-.5H7.4c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h9.2c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zM7.7 7.8l1.2-.1v-.1l.6-1.1h.1l.6 1.1v.1l1.2.1c.1 0 .1.1.1.2l-.9.8v.1l.2 1.2c0 .1-.1.1-.2.1l-1-.6h-.1l-1.1.6s-.1 0-.1-.1l.2-1.2-.1-.1-.8-.8c0-.1 0-.2.1-.2zm7.4 8c0 .3-.2.5-.5.5H8.4c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h6.2c.3 0 .5.2.5.5v.4zm1-2.8c0 .2-.2.4-.5.4H8.4c-.3 0-.5-.2-.5-.4v-.5c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5v.5z"
      }
    },
    contract_line_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.1 8.6h2.6c.2 0 .3-.1.3-.3 0-.1 0-.2-.1-.2l-3.2-3.2c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.6c0 .5.4.9.9.9zm2.4 1.5h-3.3c-.8 0-1.5-.7-1.5-1.5V5.3c0-.3-.2-.5-.5-.5H7.4c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h9.2c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zm-9.2 6.2c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm0-2.8c-.4 0-.7-.4-.7-.8s.3-.7.7-.7c.4 0 .7.3.7.7 0 .5-.3.8-.7.8zm1.2-3.9l-1.1.6s-.1 0-.1-.1l.2-1.2-.1-.1-.8-.8c0-.1 0-.2.1-.2l1.2-.1v-.1l.6-1.1h.1l.6 1.1v.1l1.2.1c.1 0 .1.1.1.2l-.9.8v.1l.2 1.2c0 .1-.1.1-.2.1l-1-.6h-.1zm6.6 6.2c0 .3-.2.5-.5.5h-4.9c-.2 0-.5-.2-.5-.5v-.4c0-.3.3-.5.5-.5h4.9c.3 0 .5.2.5.5v.4zm0-2.8c0 .2-.2.4-.5.4h-4.9c-.2 0-.5-.2-.5-.4v-.5c0-.3.3-.5.5-.5h4.9c.3 0 .5.2.5.5v.5z"
      }
    },
    custom: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19 7.9c0-.2-.3-.2-.4-.1l-2.4 2.4c-.2.2-.5.2-.7 0l-1.7-1.7c-.2-.2-.2-.5 0-.7l2.4-2.4c.2-.1.1-.4 0-.4-.5-.1-.9-.2-1.3-.2-2.6 0-4.6 2.2-4.3 4.8 0 .4.1.8.3 1.1l-5.6 5.6c-.7.7-.7 1.8 0 2.4.3.4.7.5 1.2.5s.8-.1 1.2-.5l5.6-5.6c.3.2.7.3 1.1.3 2.6.3 4.8-1.7 4.8-4.3 0-.4-.1-.8-.2-1.2z"
      }
    },
    custom_notification: {
      "path": {
        "d": "M12.9 5.2L12 9.6a.2.2 0 0 0 .3.3H17a.5.5 0 0 1 .3.7L12.2 19a.4.4 0 0 1-.8-.2l.9-5.2c0-.2-.1-.1-.3-.1H7.1c-.4 0-.6-.5-.4-.8L12.1 5a.4.4 0 0 1 .8.2z"
      }
    },
    customers: {
      "xmlns": "http://www.w3.org/2000/svg",
      "ellipse": {
        "cx": "9.912",
        "cy": "10.152",
        "rx": "2.928",
        "ry": "3.24"
      },
      "path": {
        "d": "M12.6 13.8c-.7.6-1.7 1.1-2.7 1.1-1 0-2-.5-2.7-1.1-1.3.6-2.6 1.3-2.6 2.5v.5c0 .6.4 1.1 1 1.1h8.6c.6 0 1.1-.5 1.1-1.1v-.5c0-1.2-1.3-1.9-2.7-2.5zm3.7-2.4l-.1-.1h-.3c-.5.3-1.1.5-1.7.5h-.3c-.1.3-.2.7-.4.9.1.1.2.1.3.2 1.4.6 2.4 1.3 3 2.3H18c.5 0 1-.4 1-.9v-.5c0-1.2-1.4-1.9-2.7-2.4zm-.2-3.2c0-1.2-.9-2.1-1.9-2.1-.6 0-1 .2-1.4.6.9.8 1.4 2.1 1.4 3.4v.2c1 0 1.9-.9 1.9-2.1z"
      }
    },
    dashboard: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 1.9c2.9 0 5.3 2.4 5.3 5.3 0 .2 0 .5-.1.7h-2.1c-.2 0-.4.2-.5.4-.2 1.3-1.3 2.3-2.6 2.3s-2.4-1-2.6-2.3c0-.2-.3-.4-.5-.4H6.8c-.1-.2-.1-.5-.1-.7 0-2.9 2.4-5.3 5.3-5.3zm-.6 7.1c.6.3 1.4 0 1.7-.5.4-.9 1.3-4.6 1.1-4.7-.2-.1-2.8 2.7-3.2 3.6-.4.5-.2 1.3.4 1.6z"
      }
    },
    datadotcom: {
      "path": {
        "d": "M17.1 19.2h-1.7c-.1-.6-.1-1.1-.1-1.6-.8 1.3-2.1 1.9-3.8 1.9-1.4 0-2.6-.5-3.4-1.5-.8-1-1.2-2.4-1.2-3.9 0-1.1.2-2 .6-2.8s1-1.5 1.7-2 1.6-.7 2.6-.7c1.4 0 2.5.4 3.4 1.3V4.8h1.7v12.1c0 .8.1 1.5.2 2.3zm-1.9-4.4v-3.3c-.4-.6-.9-.9-1.4-1.2-.5-.2-1.1-.4-1.8-.4-1 0-1.8.4-2.4 1.2s-.8 1.7-.8 2.9c0 1.3.2 2.2.8 3s1.3 1.1 2.3 1.1 1.8-.3 2.4-1c.6-.6.9-1.4.9-2.3z"
      }
    },
    default: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M10.7 7.9c.5-.5 1.2-.8 1.9-.8 1.1 0 1.9.5 2.4 1.3.4-.1.9-.3 1.4-.3 1.8.1 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3-.2 0-.5 0-.7-.1-.4.8-1.2 1.3-2.1 1.3-.4 0-.7-.1-1-.3-.5 1-1.4 1.7-2.6 1.7-1.2 0-2.2-.8-2.6-1.8-.2 0-.3.1-.5.1-1.4 0-2.6-1.2-2.6-2.6 0-.9.5-1.8 1.3-2.2-.2-.4-.2-.7-.2-1.2 0-1.6 1.3-2.9 2.9-2.9 1 0 1.9.5 2.4 1.2"
      }
    },
    document: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 10.1h-3.3c-.8 0-1.5-.7-1.5-1.5V5.3c0-.3-.2-.5-.5-.5H7.4c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h9.2c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zm.4-2l-3.2-3.2c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.6c0 .5.4.9.9.9h2.6c.2 0 .3-.1.3-.3 0-.1 0-.2-.1-.2z"
      }
    },
    drafts: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 4.8H9.8c-.8 0-1.4.6-1.4 1.4v.3c0 .1.1.2.2.2h7c.8 0 1.4.7 1.4 1.5v7.4c0 .1.1.2.3.2h.2c.8 0 1.5-.6 1.5-1.4V6.2c0-.8-.7-1.4-1.5-1.4zm-3.3 3.4H6.5c-.8 0-1.5.6-1.5 1.4v8.2c0 .8.7 1.4 1.5 1.4h7.7c.8 0 1.4-.6 1.4-1.4V9.6c0-.8-.6-1.4-1.4-1.4zM7 10.6c0-.3.2-.5.4-.5h4.8c.3 0 .5.2.5.5v.4c0 .3-.2.5-.5.5H7.4c-.2 0-.4-.2-.4-.5v-.4zm5.7 6.2c0 .3-.2.5-.5.5H7.4c-.2 0-.4-.2-.4-.5v-.5c0-.2.2-.5.4-.5h4.8c.3 0 .5.3.5.5v.5zm1-2.9c0 .3-.2.5-.5.5H7.4c-.2 0-.4-.2-.4-.5v-.5c0-.2.2-.4.4-.4h5.8c.3 0 .5.2.5.4v.5z"
      }
    },
    email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.7 13.2c.2.2.4.2.6 0l6.8-6.3c.1-.2.1-.6-.4-.6H5.3c-.4 0-.6.3-.4.6l6.8 6.3zm7.5-3.6c0-.3-.4-.5-.6-.3l-5.3 4.9c-.3.4-.8.5-1.3.5s-.9-.1-1.3-.5L5.4 9.3c-.2-.2-.6 0-.6.3v6.2c0 .8.7 1.5 1.5 1.5h11.5c.8 0 1.4-.7 1.4-1.5V9.6z"
      }
    },
    email_chatter: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.7 13.2c.2.2.4.2.6 0l6.8-6.3c.1-.2.1-.6-.4-.6H5.3c-.4 0-.6.3-.4.6l6.8 6.3zm7.5-3.6c0-.3-.4-.5-.6-.3l-5.3 4.9c-.3.4-.8.5-1.3.5s-.9-.1-1.3-.5L5.4 9.3c-.2-.2-.6 0-.6.3v6.2c0 .8.7 1.5 1.5 1.5h11.5c.8 0 1.4-.7 1.4-1.5V9.6z"
      }
    },
    empty: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M17.3 18.7H6.7c-.8 0-1.4-.6-1.4-1.4V6.7c0-.8.6-1.4 1.4-1.4h10.6c.8 0 1.4.6 1.4 1.4v10.6c0 .8-.6 1.4-1.4 1.4zM6.7 7.2v9.6c0 .3.2.5.5.5h9.6c.3 0 .5-.2.5-.5V7.2c0-.3-.2-.5-.5-.5H7.2c-.3 0-.5.2-.5.5z"
      }
    },
    endorsement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 10.1H5.3c-.3 0-.5.2-.5.5v7.7c0 .3.2.4.5.4h.5c.8 0 1.4-.6 1.4-1.4v-6.7c0-.3-.2-.5-.5-.5zm10.6.2h-1.5c-.8 0-1.4-.6-1.4-1.4V6c0-.8-.6-1.4-1.4-1.4h-1c-.3 0-.5.2-.5.4v2c0 1.6-.8 3.3-2.4 3.3-.2 0-.5.2-.5.5v6.7c0 .3.2.5.5.5 2.1.1 3.5.9 5.8.9 2.4 0 4.3-.7 4.3-3v-3.7c0-1-.9-1.9-1.9-1.9z"
      }
    },
    entitlement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.3 4.8H8.4c-.8 0-1.6.8-1.6 1.6h-.6c-.6 0-1.1.5-1.1 1.2s.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1 0 .7.5 1.1 1.1 1.1h.6c0 1.1.8 1.7 1.6 1.7h8.9c.8 0 1.6-.8 1.6-1.7V6.4c0-.9-.8-1.6-1.6-1.6zm-1 12c0 .3-.2.5-.4.5H9.6c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.5.5-.5h6.3c.2 0 .4.3.4.5v.5zm-6.7-4.7l.5-.5c.1-.2.4-.2.5 0l1.3 1.2 3-3.1c.2-.1.4-.1.5 0l.5.5c.2.2.2.4 0 .6l-3.6 3.5c-.1.1-.3.2-.5.2s-.3-.1-.5-.2l-1.7-1.7c-.2-.2-.2-.4 0-.5zm6.7-4.3c0 .2-.2.5-.4.5H9.6c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h6.3c.2 0 .4.2.4.5v.5z"
      }
    },
    entitlement_process: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M13.4 19.1v-4l2.3-2.5h3.2v4.8c0 1-.8 1.7-1.7 1.7h-3.8zm-1.4 0H8.4c-.8 0-1.6-.5-1.6-1.7h-.6c-.6 0-1.1-.4-1.1-1v-.1c0-.6.5-1.1 1.1-1.1h.6V13h-.6c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h.6V8.6h-.6c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.2h.6c0-.9.8-1.6 1.6-1.6h8.8c.9 0 1.7.7 1.7 1.6v4.9h-3.3L13 8.4c-.2-.2-.5-.2-.7 0l-2.9 3.2c-.2.2-.2.5 0 .7l2.6 2.8v4z"
      }
    },
    entitlement_template: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M16.9 4.7H8.1c-.9 0-1.6.7-1.6 1.6h-.6c-.6 0-1.1.5-1.1 1.1v.1c0 .6.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h.6c0 1.2.7 1.7 1.6 1.7h8.8c.9 0 1.7-.7 1.7-1.7V6.3c0-.9-.8-1.6-1.7-1.6zm-.8 10.8H8.8V8.3h7.3v7.2zm-6-4.7h4.8c.1 0 .1 0 .1-.1V9.6c0-.1 0-.2-.1-.2h-4.8c-.1 0-.2 0-.2.1v1.1c0 .1.1.2.2.2zm0 3.6h1.1c.1 0 .2 0 .2-.1v-2.2c0-.1-.1-.2-.2-.2h-1.1c-.1 0-.2.1-.2.1v2.2c0 .1.1.2.2.2zm4.7-2.5h-2.2c-.1 0-.2.1-.2.2v2.2c0 .1.1.1.2.1h2.2c.1 0 .2 0 .2-.1v-2.2c0-.1 0-.2-.1-.2h-.1z"
      }
    },
    entity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.9 6.9c0-1.2-2.7-2.1-5.9-2.1s-5.9.9-5.9 2.1v.7c0 1.2 2.7 2.1 5.9 2.1s5.9-.9 5.9-2.1v-.7zM6.1 9.3c0 .9 2.7 1.6 5.9 1.6s5.9-.7 5.9-1.6v1.5c0 1.1-2.7 2.1-5.9 2.1s-5.9-1-5.9-2.1V9.3zm0 0c0 .9 2.7 1.6 5.9 1.6s5.9-.7 5.9-1.6v1.5c0 1.1-2.7 2.1-5.9 2.1s-5.9-1-5.9-2.1V9.3zm0 3.2c0 .9 2.7 1.6 5.9 1.6s5.9-.7 5.9-1.6v1.4c0 1.2-2.7 2.1-5.9 2.1s-5.9-.9-5.9-2v-1.5zm0 3.1c0 1 2.7 1.7 5.9 1.7s5.9-.7 5.9-1.7v1.5c0 1.2-2.7 2.1-5.9 2.1s-5.9-.9-5.9-2.1v-1.5z"
      }
    },
    entity_milestone: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.8 7.9l-5.1-2.8c-.4-.3-1-.3-1.5 0L6.1 7.9c-.4.3-.7.8-.7 1.3v5.7c0 .5.3 1 .7 1.3l5.1 2.9c.5.2 1.1.2 1.5 0l5.1-2.9c.5-.3.8-.8.8-1.3V9.2c0-.5-.3-1-.8-1.3zm-8 1.8v6c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-6c-.2-.1-.3-.4-.3-.6 0-.4.4-.7.8-.7s.8.3.8.8c0 .2-.1.4-.3.5zm6.2 3.8c0 .1-.1.2-.2.2-2 1.1-3.1-.7-4.9-.1-.1.1-.3 0-.3-.2V10c0-.1.1-.2.2-.3 1.8-.7 3 1.2 5 .1h.1c0 .1.1.1.1.1v3.6z"
      }
    },
    environment_hub: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.3 11.3c.1-1 .4-2 .9-2.9.8-1.3 2.1-2.1 3.8-2.2.3-.8 1.1-1.4 2-1.4 1.2 0 2.2 1 2.2 2.2s-1 2.1-2.2 2.1c-.9 0-1.7-.6-2-1.4-1.9.1-3 1.6-3.2 3.6H15c.3-.9 1.1-1.5 2-1.5 1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2c-.9 0-1.7-.6-2-1.5h-3.2c.2 2.2 1.2 3.6 3.2 3.6.3-.8 1.1-1.4 2-1.4 1.2 0 2.2.9 2.2 2.1s-1 2.2-2.2 2.2c-.9 0-1.7-.6-2-1.4-1.8 0-3.1-.8-3.9-2.2-.4-.9-.7-1.8-.8-2.9H9c-.3.9-1.1 1.5-2 1.5-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c.9 0 1.7.6 2 1.5h1.3zM17 7.7c.4 0 .8-.3.8-.7s-.4-.8-.8-.8-.7.4-.7.8.3.7.7.7zm0 10.1c.4 0 .8-.4.8-.8s-.4-.7-.8-.7-.7.3-.7.7.3.8.7.8zm0-5.1c.4 0 .8-.3.8-.7s-.4-.7-.8-.7-.7.3-.7.7.3.7.7.7zm-10 0c.4 0 .7-.3.7-.7s-.3-.7-.7-.7-.8.3-.8.7.4.7.8.7z"
      }
    },
    event: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.2 10.1H5.8c-.3 0-.5.2-.5.5v7.2c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zm-8.6 6.7c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4h.9c.3 0 .5.2.5.4v1zm0-3.4c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h.9c.3 0 .5.2.5.5v.9zm3.4 3.4c0 .3-.3.5-.5.5h-1c-.2 0-.5-.2-.5-.5v-1c0-.2.3-.4.5-.4h1c.2 0 .5.2.5.4v1zm0-3.4c0 .3-.3.5-.5.5h-1c-.2 0-.5-.2-.5-.5v-.9c0-.3.3-.5.5-.5h1c.2 0 .5.2.5.5v.9zm3.3 3.4c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4h.9c.3 0 .5.2.5.4v1zm0-3.4c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h.9c.3 0 .5.2.5.5v.9zm1-7.2h-1.2v-.4c0-.6-.5-1-1-1s-.9.4-.9 1v.4H9.8v-.4c0-.6-.4-1-.9-1s-1 .4-1 1v.4H6.7c-.8 0-1.4.7-1.4 1.5v.5c0 .2.2.4.5.4h12.4c.3 0 .5-.2.5-.4v-.5c0-.8-.6-1.5-1.4-1.5z"
      }
    },
    feed: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 17.3c-.1 0-.3 0-.4-.1-.2-.1-.3-.3-.4-.5L9.2 9.2l-1.6 3.5c-.1.3-.4.5-.6.5H4.8c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h1.7l2.2-5.1c.1-.3.4-.5.7-.5.3.1.6.3.7.6l1.9 7.6 2.4-5.6c.2-.3.5-.4.8-.4.2 0 .5.2.6.5l1.2 2.9h2.2c.3 0 .5.2.5.4v.5c0 .3-.2.5-.5.5h-2.6c-.3 0-.6-.2-.7-.4l-.8-1.9-2.7 5.9c-.1.3-.4.5-.6.5z"
      }
    },
    feedback: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19 13.6v-.3c.4-.8.7-1.6.7-2.5 0-2.8-2.4-5-5.3-5-1.2 0-2.4.4-3.3 1.1 3 .6 5.2 3.2 5.2 6.3 0 .9-.1 1.7-.5 2.4.5-.1 1-.3 1.4-.5.1-.1.2-.1.3-.1l1.5.6c.3.1.5-.2.5-.5l-.5-1.5zM9.6 8.2c-2.9 0-5.3 2.2-5.3 5 0 .9.3 1.7.7 2.5 0 .1.1.2 0 .3l-.5 1.6c-.1.3.2.5.5.4l1.5-.5c.1-.1.2-.1.3 0 .8.5 1.8.7 2.8.7 2.9 0 5.3-2.2 5.3-5s-2.4-5-5.3-5zm-2.9 6c-.5 0-.9-.5-.9-1s.4-1 .9-1 1 .5 1 1-.5 1-1 1zm2.9 0c-.5 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1zm2.9 0c-.5 0-1-.5-1-1s.5-1 1-1 .9.5.9 1-.4 1-.9 1z"
      }
    },
    file: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7 15.1V7.4c-.8 0-1.5.7-1.5 1.5V18c0 .8.7 1.4 1.5 1.4h7.2c.8 0 1.4-.6 1.4-1.4H9.8C8.3 18 7 18 7 15.1zm11-6.2h-2.4c-.8 0-1.4-.7-1.4-1.5V5c0-.2-.3-.4-.5-.4H9.8c-.8 0-1.4.6-1.4 1.4v9.1c0 .8.6 1.5 1.4 1.5H17c.8 0 1.5-.7 1.5-1.5V9.4c0-.3-.2-.5-.5-.5zm.4-2l-2.2-2.2c-.1-.1-.2-.1-.3-.1-.2 0-.3.1-.3.3v1.6c0 .5.4.9 1 .9h1.5c.2 0 .4-.1.4-.3 0-.1 0-.2-.1-.2z"
      }
    },
    flow: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 7.4C18.6 6.1 17 3.9 14 5.2c-1.8.8-2.8 1.3-2.8 1.3L8.5 7.7c-.7.3-2.4-.2-3.3-.5-.2-.1-.5.2-.4.5.7 1.2 2.3 3.5 5.2 2.1 1.8-.8 5.5-2.4 5.5-2.4.7-.4 2.4.1 3.3.5.3 0 .5-.2.4-.5zm-6.4 3.8c-.3.2-1.6.8-1.6.8l-1.3.6c-.7.4-2.1-.1-2.9-.5-.3-.1-.5.2-.4.5.6 1.2 2 3.3 4.6 2 1.6-.8 2.9-1.3 2.9-1.3.7-.4 2.1.1 2.9.4.3.1.5-.2.4-.4-.6-1.2-2-3.4-4.6-2.1zm-.9 5.3c-.3.2-.7.5-.7.5-.5.3-1.6-.1-2.2-.4-.2-.1-.4.2-.3.4.4 1.1 1.5 3 3.4 1.8l.7-.4c.6-.3 1.6.1 2.2.4.2.1.4-.2.3-.5-.4-1-1.4-2.9-3.4-1.8z"
      }
    },
    folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18 8.3h-6.8c-.4 0-.8-.2-1.1-.6l-1-1.8c-.2-.4-.6-.6-1.1-.6H6c-.7 0-1.2.5-1.2 1.2v11c0 .7.5 1.2 1.2 1.2h12c.7 0 1.2-.5 1.2-1.2V9.6c0-.7-.5-1.3-1.2-1.3zm0-2.4h-7.2c-.1 0-.2.1-.1.2l.4.8c.1.1.2.2.3.2H18c.3 0 .7.1.9.2.2.1.3 0 .3-.2 0-.7-.5-1.2-1.2-1.2z"
      }
    },
    forecasts: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 7s-.8-1.7-2.7-1.7-2.7 1.8-2.7 1.8c-1.3-.6-2.4 0-2.4 0s-.9-1.8-2.7-1.8S5.4 7 5.4 7s-1.8 3.9-1.8 7.4c-.1 3.5 2.2 4.3 3.3 4.3 1.2 0 4.1-.5 3.9-4.4 0 0 .3-.7 1.1-.7 1 0 1.3.7 1.3.7-.1 3.9 2.7 4.4 3.9 4.4 1 0 3.4-.8 3.3-4.3 0-3.5-1.8-7.4-1.8-7.4zM7.2 17.2c-1.2 0-2.1-1-2.1-2.1S6 13 7.2 13s2 .9 2 2.1-.9 2.1-2 2.1zm9.6 0c-1.1 0-2-1-2-2.1s.9-2.1 2-2.1 2.1.9 2.1 2.1-.9 2.1-2.1 2.1z"
      }
    },
    generic_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".15",
        "d": "M12.4 5.3h-.8c-.2 0-.3.1-.3.3v3.2c0 .2.1.3.3.3h.8c.2 0 .3-.1.3-.3V5.6c0-.2-.1-.3-.3-.3zm6 6h-3.2c-.2 0-.3.1-.3.3v.8c0 .2.1.3.3.3h3.2c.2 0 .3-.1.3-.3v-.8c0-.2-.1-.3-.3-.3zm-6 3.6h-.8c-.2 0-.3.1-.3.3v3.2c0 .2.1.3.3.3h.8c.2 0 .3-.1.3-.3v-3.2c0-.2-.1-.3-.3-.3zm-3.3-2.5v-.8c0-.2-.1-.3-.3-.3H5.6c-.2 0-.3.1-.3.3v.8c0 .2.1.3.3.3h3.2c.2 0 .3-.1.3-.3zm5.2-2.2c.1.2.3.2.5 0L17 8c.1-.1.1-.3 0-.5l-.5-.5c-.2-.1-.4-.1-.5 0l-2.2 2.2c-.2.2-.2.4 0 .5l.5.5zm.5 3.6c-.1-.2-.4-.2-.5 0l-.5.5c-.1.1-.1.3 0 .5L16 17c.2.1.4.1.5 0l.5-.5c.2-.2.2-.4 0-.5l-2.2-2.2zm-5.1 0c-.1-.2-.3-.2-.5 0L7 16c-.1.1-.1.3 0 .5l.5.5c.2.1.4.1.5 0l2.2-2.2c.2-.2.2-.4 0-.5l-.5-.5zM8 7c-.1-.2-.3-.2-.5 0l-.5.5c-.1.1-.1.3 0 .5l2.2 2.2c.2.1.4.1.5 0l.5-.5c.2-.1.2-.4 0-.5L8 7z"
      }
    },
    goals: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.2 4.8c-.8 0-1.4.6-1.4 1.4 0 .5.2.9.5 1.1v10.9c0 .6.4 1 .9 1s1-.4 1-1V7.3c.3-.2.5-.6.5-1.1 0-.8-.7-1.4-1.5-1.4zm12.2 2.6c-3.8 2-5.9-1.4-9.4-.1-.2 0-.4.2-.4.4v6.2c0 .3.4.6.7.5 3.4-1.1 5.5 2.2 9.2.1.1-.1.2-.2.2-.4V7.6c0-.2-.2-.3-.3-.2zm-1.1 3.3c-.5.1-.9.1-1.4.1h-.1v1.4h.1c.5 0 .9 0 1.4-.1v1.4c-.5.2-.9.2-1.4.2h-.1v-1.4c-.4 0-.9-.1-1.4-.2v1.4c-.3 0-.7-.1-1-.2-.2-.1-.3-.1-.4-.2v-1.4c-.6-.2-1-.3-1.5-.4v1.5c-.2-.1-.5-.1-.8-.1-.2 0-.4 0-.6.1v-1.5h1.4V10c-.2-.1-.5-.1-.8-.1h-.6V8.5c.2-.1.4-.1.6-.1.3 0 .6.1.8.1V10c.4.1.7.2 1.3.3 0 .1.1.1.2.1V9c.4.1.9.2 1.4.3v1.4c.5.1.9.1 1.4.1V9.4h.1c.5 0 .9 0 1.4-.1v1.4zm-4.3-.3v1.3c.1 0 .2.1.3.1.4.1.7.2 1.1.3v-1.4c-.5-.1-1-.2-1.4-.3z"
      }
    },
    group_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M8.8 12.6c-.4-.7-.6-1.4-.6-2.3 0-1.4.6-2.6 1.5-3.3-.3-.6-.9-1-1.8-1-1.4 0-2.1 1.1-2.1 2.4 0 .7.2 1.3.7 1.7.2.2.4.6.4.9 0 .3-.1.6-.9 1-1.1.5-2.1 1.1-2.2 2.2 0 .7.5 1.2 1.1 1.2H6c.1 0 .3-.1.4-.3.5-.9 1.4-1.5 2.2-1.9.3-.1.4-.4.2-.6zM18 12c-.8-.4-.9-.7-.9-1 0-.3.2-.7.4-.9.5-.4.7-1 .7-1.7 0-1.3-.7-2.4-2.1-2.4-.9 0-1.5.4-1.8 1 .9.7 1.5 1.9 1.5 3.3 0 .9-.2 1.6-.6 2.3-.2.2-.1.5.2.7.8.4 1.7.9 2.2 1.8.1.2.3.3.4.3h1.1c.6 0 1.1-.5 1.1-1.2-.1-1.1-1.1-1.7-2.2-2.2zm-3.9 2.3c-.9-.4-1-.7-1-1.1 0-.4.2-.7.5-1 .5-.4.8-1.1.8-1.9 0-1.4-.8-2.6-2.4-2.6s-2.4 1.2-2.4 2.6c0 .8.3 1.4.8 1.9.3.3.5.6.5 1s-.1.7-.9 1.1c-1.3.5-2.5 1.1-2.6 2.3 0 .7.6 1.4 1.3 1.4h6.6c.7 0 1.3-.7 1.3-1.4-.1-1.2-1.3-1.8-2.5-2.3z"
      }
    },
    groups: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.8 12.6c-.4-.7-.6-1.4-.6-2.3 0-1.4.6-2.6 1.5-3.3-.3-.6-.9-1-1.8-1-1.4 0-2.1 1.1-2.1 2.4 0 .7.2 1.3.7 1.7.2.2.4.6.4.9 0 .3-.1.6-.9 1-1.1.5-2.1 1.1-2.2 2.2 0 .7.5 1.2 1.1 1.2H6c.1 0 .3-.1.4-.3.5-.9 1.4-1.5 2.2-1.9.3-.1.4-.4.2-.6zM18 12c-.8-.4-.9-.7-.9-1 0-.3.2-.7.4-.9.5-.4.7-1 .7-1.7 0-1.3-.7-2.4-2.1-2.4-.9 0-1.5.4-1.8 1 .9.7 1.5 1.9 1.5 3.3 0 .9-.2 1.6-.6 2.3-.2.2-.1.5.2.7.8.4 1.7.9 2.2 1.8.1.2.3.3.4.3h1.1c.6 0 1.1-.5 1.1-1.2-.1-1.1-1.1-1.7-2.2-2.2zm-3.9 2.3c-.9-.4-1-.7-1-1.1 0-.4.2-.7.5-1 .5-.4.8-1.1.8-1.9 0-1.4-.8-2.6-2.4-2.6s-2.4 1.2-2.4 2.6c0 .8.3 1.4.8 1.9.3.3.5.6.5 1s-.1.7-.9 1.1c-1.3.5-2.5 1.1-2.6 2.3 0 .7.6 1.4 1.3 1.4h6.6c.7 0 1.3-.7 1.3-1.4-.1-1.2-1.3-1.8-2.5-2.3z"
      }
    },
    hierarchy: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.1 11.1h-4c-.3 0-.5.2-.5.5V15H5.2c-.2 0-.4.2-.4.4v3.4c0 .2.2.4.4.4h4.5c.3 0 .5-.2.5-.4v-3.4c0-.2-.2-.4-.5-.4H8.4v-2.1h7.2V15h-1.3c-.3 0-.5.2-.5.4v3.4c0 .2.2.4.5.4h4.5c.2 0 .4-.2.4-.4v-3.4c0-.2-.2-.4-.4-.4h-1.4v-3.4c0-.3-.2-.5-.5-.5h-4V9h1.3c.3 0 .5-.2.5-.4V5.3c0-.3-.2-.5-.5-.5H9.7c-.2 0-.4.2-.4.5v3.3c0 .2.2.4.4.4h1.4v2.1z"
      }
    },
    home: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 12.3h-1.5v6.6c0 .2-.1.3-.3.3h-3c-.2 0-.3-.1-.3-.3v-5.1h-3.6v5.1c0 .2-.1.3-.3.3h-3c-.2 0-.3-.1-.3-.3v-6.6H5.1c-.1 0-.3-.1-.3-.2s0-.2.1-.3l6.9-7c.1-.1.3-.1.4 0l7 7v.3c0 .1-.2.2-.3.2z"
      }
    },
    household: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.4 4.9c-.3-.1-.6-.1-.8 0L5 11.1c-.4.3-.2.9.3.9h.9v5.8c0 .8.7 1.4 1.5 1.4h8.6c.8 0 1.5-.6 1.5-1.4V12h.9c.5 0 .7-.6.3-.9l-6.6-6.2zM8.9 15.3c-.1.1-.2.1-.3.1H8c-.3 0-.6-.2-.6-.6.1-.6.6-.9 1.3-1.1.4-.2.5-.4.5-.6 0-.2-.2-.4-.3-.5-.3-.2-.4-.6-.4-1 0-.7.5-1.3 1.2-1.3.5 0 .8.2 1 .5-.5.5-.9 1.1-.9 1.9 0 .5.2.9.4 1.3.1.1 0 .3-.1.3-.4.2-1 .5-1.2 1zm4.9 1.7h-3.6c-.4 0-.7-.3-.7-.8 0-.6.7-1 1.3-1.3.5-.2.6-.4.6-.6 0-.2-.1-.4-.3-.5-.3-.3-.4-.6-.4-1.1 0-.8.5-1.5 1.3-1.5s1.4.7 1.4 1.5c0 .5-.2.8-.5 1.1-.1.1-.3.3-.3.5s.1.4.6.6c.7.3 1.4.7 1.4 1.3-.1.5-.4.8-.8.8zm2.2-1.6h-.6c-.1 0-.2 0-.3-.1-.2-.5-.8-.7-1.2-.9-.1-.1-.2-.2-.1-.4.2-.3.4-.8.4-1.2 0-.8-.4-1.5-.9-1.9.2-.3.5-.6 1-.6.8 0 1.2.7 1.2 1.4 0 .4-.1.7-.4.9-.1.2-.2.4-.2.6s0 .3.5.5c.6.3 1.2.6 1.2 1.1 0 .4-.3.6-.6.6z"
      }
    },
    insights: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 6.5H7.4c-.2 0-.4.1-.4.4v8.4c0 .3-.3.6-.6.6-.3-.1-.5-.3-.5-.6V9.2c0-.1-.1-.2-.3-.2h-.4c-.2 0-.4.1-.4.4v7c0 .6.5 1.1 1.1 1.1h12.2c.6 0 1.1-.5 1.1-1.1V6.9c0-.3-.2-.4-.4-.4zm-6.2 8c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.2.3-.2h3.3c.1 0 .3.1.3.2v.6zm0-2.2c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.3.3-.3h3.3c.1 0 .3.2.3.3v.6zm4.9 2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.2.2-.2h3.4c.1 0 .2.1.2.2v.6zm0-2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.3.2-.3h3.4c.1 0 .2.2.2.3v.6zm0-2.2c0 .1-.1.2-.2.2H9c-.2 0-.3-.1-.3-.2V8.4c0-.2.1-.3.3-.3h8.3c.1 0 .2.1.2.3v1.7z"
      }
    },
    investment_account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 6.5H6.2c-.8 0-1.4.6-1.4 1.4v8.2c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4V7.9c0-.8-.6-1.4-1.4-1.4zM16.6 13c0 .2-.3.3-.4.1L15 12l-2.5 2.2c-.3.3-.7.3-1 0L10 12.5l-2.8 2.4c-.1.1-.2.1-.3 0l-.1-.2c-.1-.1-.1-.2 0-.3l2.7-3.7c.2-.3.7-.3 1 0l1.5 1.6 1.6-1.8-1-.9c-.2-.2-.1-.5.1-.5h3.4c.2 0 .4.3.4.5V13z"
      }
    },
    iot_orchestrations: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill": "#FFF",
        "fill-rule": "evenodd",
        "circle": [{
          "cx": "9.36",
          "cy": "7.68",
          "r": "2.88"
        }, {
          "cx": "16.8",
          "cy": "12",
          "r": "2.88"
        }],
        "path": {
          "fill-rule": "nonzero",
          "d": "M9.4 17.8c.8 0 1.4-.7 1.4-1.5s-.6-1.4-1.4-1.4-1.5.6-1.5 1.4.7 1.5 1.5 1.5zm0 1.4c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.8 1.3 2.8 2.9-1.2 2.9-2.8 2.9zM11 9.9c.8 1.1 2 1.7 3.4 1.9.2 0 .5-.2.5-.5 0-.2-.2-.5-.4-.5-1.2-.1-2.1-.6-2.8-1.5-.1-.2-.4-.2-.7-.1-.2.2-.2.5 0 .7zM6.7-12.5c.5-1.2.5-2.5.1-3.8-.1-.3-.4-.4-.6-.3-.3.1-.4.4-.3.6.4 1.1.3 2.1-.1 3.1-.1.3 0 .6.2.7.3.1.6 0 .7-.3zm4.8 18.7c.9-.5 1.9-.6 2.8-.2 1 .4 1.6 1.2 1.9 2 .1.4.1.6.1 1.5 0 .3.2.5.5.5s.5-.2.5-.5c0-1-.1-1.3-.2-1.8-.3-1-1.1-2-2.4-2.6-1.3-.5-2.5-.4-3.7.2-.2.2-.3.5-.1.7.1.2.4.3.6.2zm0 11.6c.9.5 1.9.6 2.8.2 1-.4 1.6-1.2 1.9-2 .1-.4.1-.6.1-1.5 0-.2.2-.5.5-.5s.5.3.5.5c0 1-.1 1.3-.2 1.8-.3 1-1.1 2-2.4 2.6-1.3.5-2.5.4-3.7-.2-.2-.2-.3-.5-.1-.7.1-.2.4-.3.6-.2z"
        }
      }
    },
    lead: {
      "xmlns": "http://www.w3.org/2000/svg",
      "circle": {
        "cx": "12",
        "cy": "6.96",
        "r": "2.16"
      },
      "path": {
        "d": "M18.7 10.6H5.3c-.5 0-.7.6-.3.8l3.5 2.3c.2.1.3.3.2.5l-1.3 4.4c-.2.5.5.8.8.5l3.4-3.6c.2-.3.6-.3.8 0l3.4 3.6c.3.3.9 0 .8-.5l-1.3-4.4c-.1-.2 0-.4.2-.5l3.5-2.3c.4-.2.2-.8-.3-.8z"
      }
    },
    lead_insights: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M12 5.3a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4zm0 12.6c-3.3 0-5.9-2.6-5.9-5.9 0-3.3 2.6-5.9 5.9-5.9 3.3 0 5.9 2.6 5.9 5.9 0 3.3-2.6 5.9-5.9 5.9z"
      }, {
        "d": "M11.8 11.8c0 .6-.2 1.1-.4 1.5-.2.4-.5.7-1 1-.4.2-.9.3-1.5.3v-.5c.7 0 1.2-.2 1.6-.5s.6-.7.7-1.3c-.4.4-.9.6-1.4.6-.3 0-.5-.1-.8-.2s-.4-.3-.5-.6c-.2-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.3.3-.5.6-.6.3-.2.6-.3.9-.3.6 0 1.1.2 1.4.6s.4.9.4 1.6zm-.6-.1c0-.5-.1-.9-.3-1.2-.1-.3-.5-.4-.9-.4-.3 0-.6.1-.8.3-.2.2-.3.5-.3.9s.1.6.3.8c.2.2.4.3.8.3.2 0 .4-.1.7-.2s.3-.3.5-.5zm4.7.1c0 .6-.2 1.1-.4 1.5-.2.4-.5.7-1 1-.4.2-.9.3-1.5.3v-.5c.7 0 1.2-.2 1.6-.5s.6-.7.7-1.3c-.4.4-.9.6-1.4.6-.3 0-.5-.1-.8-.2s-.4-.3-.5-.6c-.2-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.3.3-.5.6-.6.3-.2.6-.3.9-.3.6 0 1.1.2 1.4.6s.4.9.4 1.6zm-.6-.1c0-.5-.1-.9-.3-1.2-.2-.3-.5-.4-.9-.4-.3 0-.6.1-.9.3-.1.2-.2.5-.2.9s.1.6.2.8c.2.2.5.3.8.3.3 0 .5-.1.7-.2s.4-.3.6-.5z"
      }]
    },
    lead_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M8.9 15h9.6c.2 0 .5.2.5.4v1c0 .3-.3.5-.5.5H8.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4zM6 16.9H5c-.2 0-.4-.2-.4-.5v-1c0-.2.2-.4.4-.4h1c.3 0 .5.2.5.4v1c0 .2-.2.4-.5.5zm0-4.3H5c-.2 0-.4-.2-.4-.5v-1c0-.2.2-.4.4-.4h1c.3 0 .5.2.5.4v1c0 .2-.2.5-.5.5zm0-4.3H5c-.2 0-.4-.2-.4-.5v-1c0-.2.2-.4.4-.4h1c.3 0 .5.2.5.4v1c0 .2-.2.5-.5.5zm2.9 2.4h8.4c.3 0 .5.2.5.4v1c0 .3-.2.5-.5.5H8.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4zm0-4.3h9.6c.2 0 .5.2.5.5v.9c0 .3-.3.5-.5.5H8.9c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5z"
      }
    },
    link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.4 16.7c-.3-.1-.4-.1-.7-.1-.2-.1-.4-.1-.6-.2-.1-.1-.3 0-.4.1l-.1.1c-.9.9-2.3 1-3.2.2-1-.9-1.1-2.4-.1-3.4l2.3-2.3c.2-.3.6-.5 1-.6.5-.1 1-.1 1.4.1.3.2.6.3.8.5.1.2.2.3.3.4.1.2.4.3.5.1l.9-.8c.1-.1.1-.3 0-.5-.1-.1-.3-.3-.4-.5-.2-.2-.5-.4-.7-.5-.5-.3-.9-.5-1.4-.6-1-.2-2 0-2.8.4-.4.2-.7.5-1 .7L6 12c-1.6 1.6-1.7 4.2-.2 5.8 1.6 1.8 4.3 1.8 6 .2l.7-.8c.3-.2.1-.5-.1-.5zm5.5-10.8c-1.7-1.5-4.2-1.4-5.8.2l-.7.6c-.2.2-.1.6.2.6.4 0 .9.1 1.3.3.1 0 .3 0 .3-.1l.2-.2c.9-.8 2.2-.9 3.2-.1 1 .9 1 2.4.1 3.3l-2.3 2.3c-.3.3-.6.5-1 .6-.5.1-1 .1-1.4-.1-.3-.1-.6-.3-.8-.5-.1-.1-.2-.2-.3-.4-.1-.2-.4-.2-.6 0l-.8.8c-.1.1-.1.3 0 .5.1.1.2.3.4.4.2.3.4.4.7.6.4.3.9.4 1.4.5.9.2 1.9.1 2.8-.4.3-.2.7-.4.9-.7l2.3-2.3c1.6-1.6 1.6-4.3-.1-5.9z"
      }
    },
    list_email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.6 8.4H7.3c-.7 0-1.2.5-1.2 1.1v.2c0 .1.1.2.2.2H14c.7 0 1.2.5 1.2 1.2v5.5c0 .1.1.2.2.2h.2c.6 0 1.1-.6 1.1-1.2V9.5c0-.6-.5-1.1-1.1-1.1zm2.5-2.5H9.8c-.7 0-1.2.5-1.2 1.2v.1c0 .1.1.2.2.2h7.7c.7 0 1.2.6 1.2 1.2v5.5c0 .1.1.2.2.2h.1c.7 0 1.2-.5 1.2-1.1V7.1c0-.7-.5-1.2-1.1-1.2zm-8.9 9.5c.2.1.3.1.4 0l4.4-4.1c.1-.1.1-.4-.2-.4H5.1c-.2 0-.4.3-.3.5l4.4 4zm4.9-2.5c0-.2-.2-.3-.4-.2l-3.4 3.2c-.2.2-.5.3-.8.3-.4 0-.6-.1-.9-.3l-3.4-3.2c-.1-.1-.4 0-.4.2v4.4c0 .5.4.8.8.8h7.7c.5 0 .8-.4.8-.8v-4.4z"
      }
    },
    live_chat: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 5.3c-4 0-7.2 2.9-7.2 6.5 0 1.2.3 2.3.8 3.2.1.2.2.4.1.5l-.9 2.6c-.1.2.1.5.4.4l2.6-1c.1-.1.3 0 .5.1 1.1.6 2.4.9 3.8.9 3.9 0 7.1-2.9 7.1-6.6 0-3.7-3.2-6.6-7.2-6.6zm-3.6 7.8c-.7 0-1.2-.6-1.2-1.2 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2-.6 1.2-1.2 1.2zm3.6 0c-.7 0-1.2-.6-1.2-1.2 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2-.5 1.2-1.2 1.2zm3.6 0c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2s1.2.5 1.2 1.2-.5 1.2-1.2 1.2z"
      }
    },
    location: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 6.8l-4.3-2.2a.8.8 0 0 0-.6 0l-4 2-4.1-2a.7.7 0 0 0-.7.1.7.7 0 0 0-.3.6v10.8a.7.7 0 0 0 .4.6l4.3 2.1a.8.8 0 0 0 .6 0l4-2 4 2a.6.6 0 0 0 .3.1.7.7 0 0 0 .4-.1.7.7 0 0 0 .4-.6V7.4a.7.7 0 0 0-.4-.6zm-1.1 1.4v5.7a.4.4 0 0 1-.6.4c-1.2-.4-.3-2.3-1.1-3.3-.7-.9-1.7 0-2.6-1.4-.9-1.4.3-2.5 1.4-3a.5.5 0 0 1 .4 0l2.2 1.1a.5.5 0 0 1 .3.5zm-6.1 8.3a.5.5 0 0 1-.5-.1 1.6 1.6 0 0 1-.6-1.1c0-.7-1.2-.4-1.2-1.9 0-1.2-1.3-1.5-2.5-1.3a.5.5 0 0 1-.5-.5V7.2a.4.4 0 0 1 .6-.4l2.6 1.3a.1.1 0 0 1 .1 0l.1.1c1.1.6.8 1.1.4 1.9-.5.9-.7 0-1.4-.3s-1.5.3-1.2.8.9 0 1.4.4.5 1.2 1.9.8 1.7-.3 2.2.2a1.5 1.5 0 0 1 0 2.2c-.4.4-.6 1.3-.8 1.9a.5.5 0 0 1-.2.3z"
      }
    },
    log_a_call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.7 4.8h-9c-.8 0-1.5.7-1.5 1.4v.5h-.4c-.6 0-1 .5-1 1s.4.9 1 .9h.4V11h-.4c-.6 0-1 .5-1 1s.4 1 1 1h.4v2.4h-.4c-.6 0-1 .4-1 .9s.4 1 1 1h.4v.5c0 .7.7 1.4 1.5 1.4h9c.8 0 1.5-.7 1.5-1.5V6.2c0-.8-.7-1.4-1.5-1.4zm-.8 9.7l-.7.6c-.2.2-.4.3-.6.3-1.5-.1-3-.9-4.1-1.9-1-1-1.8-2.5-1.8-4.1 0-.2 0-.4.2-.6l.7-.6c.3-.4.8-.3 1.1 0l.6.8c.2.3.2.6 0 .9l-.5.8c-.1.1-.1.2 0 .3l1.1 1.2 1.2 1.1c.1.1.2.1.3 0l.8-.5c.2-.2.6-.2.9 0l.8.6c.3.2.3.8 0 1.1z"
      }
    },
    macros: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M15.5 16.2c0 .1-.1.1-.3.1h-1.4c-.1 0-.2-.1-.2-.2l.1-.1v-.1l3.1-3.7c.1-.1.1-.3 0-.4L13.7 8c-.1-.1-.1-.1-.1-.2s.2-.2.2-.2h1.4c.2 0 .3.1.3.2l3.3 4c.1 0 .1.1.1.2s-.1.1-.1.2l-3.3 4zm-3.4 0c-.1.1-.2.1-.3.1h-1.4c-.1 0-.2-.1-.2-.2V16l.1-.1 3-3.7c.1-.1.2-.3.1-.4L10.2 8v-.2c0-.1.1-.2.2-.2h1.4c.1 0 .2.1.3.2l3.3 4v.4l-3.3 4zm-3.5 0c0 .1-.1.1-.2.1H5.7c-.1 0-.2-.1-.2-.2V16h.1v-.1l3.1-3.7c.1-.1.1-.3 0-.4L5.6 8c-.1-.1-.1-.1-.1-.2s.1-.2.2-.2h2.6c.1 0 .3.1.3.2l3.3 4c.1 0 .1.1.1.2s-.1.1-.1.2l-3.3 4z"
      }
    },
    maintenance_asset: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.2 7.3c0 .1.1.2.2.2H18c.3 0 .7.1 1 .2.1.1.2 0 .2-.2 0-.7-.5-1.2-1.2-1.2h-7.2c-.1 0-.1 0-.1.1v.1l.5.8zM18 8.7h-6.8c-.4 0-.8-.2-1-.6L9.1 6.3c-.2-.4-.6-.6-1-.6H6c-.6 0-1.2.5-1.2 1.2v11c0 .7.5 1.2 1.2 1.2h12c.7 0 1.2-.5 1.2-1.2V10c0-.7-.5-1.2-1.2-1.3zm-3.1 8c-.3.3-.7.3-1 .1v-.1l-2.4-2.3c-.1 0-.3 0-.5.1-1 .1-1.9-.7-2-1.7v-.2-.5c.1 0 .1-.1.2-.1v.1l1 1c.1.1.3.1.3 0l.8-.7v-.3l-1.1-1v-.2h.1c.1-.1.3-.1.5-.1 1 0 1.8.8 1.8 1.9v.2c0 .1 0 .3-.1.4l2.4 2.4c.3.3.3.7.1 1-.1 0-.1.1-.1 0z"
      }
    },
    maintenance_plan: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M15.8 8.2h1.9c.2 0 .4-.2.4-.4 0-.1-.1-.3-.1-.3l-2.8-2.7c0-.1-.1-.1-.2-.1-.2 0-.4.2-.4.4V7c0 .6.5 1.1 1.2 1.2zm1.6 1.6h-2.9c-.9 0-1.7-.7-1.7-1.7V5.2c0-.3-.2-.5-.5-.5H7.6c-1 0-1.7.7-1.8 1.7v11c0 .9.8 1.7 1.8 1.7h8.7c.9 0 1.7-.8 1.7-1.7v-7c0-.3-.2-.6-.6-.6zm-1.6 7.4c-.2.2-.4.3-.7.3-.3 0-.6-.1-.7-.3L11 13.9c-.2.1-.4.2-.6.2-1.4.2-2.7-.9-2.8-2.2-.1-.4 0-.8.1-1.1 0-.1.1-.1.2 0l1.4 1.4c.1.1.3.1.4 0l1.1-1c.1-.1.1-.3 0-.4L9.3 9.3v-.2h.1c.2-.1.5-.1.7-.1 1.4 0 2.5 1.1 2.6 2.5 0 .1 0 .2-.1.3 0 .3 0 .5-.1.7l3.3 3.3c.4.4.4 1 0 1.4z"
      }
    },
    marketing_actions: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.4 6.2c-1.2.1-2.2 1.1-2.3 2.3.1-1.2 1.1-2.2 2.3-2.3zm2.5 2.3c-.1-1.2-1-2.2-2.3-2.3 1.3.1 2.3 1.1 2.3 2.3zm1.4 4.7l-2.5-.9c-.2-.1-.3-.2-.3-.4V8.6c0-.5-.4-.9-.9-.9h-.1c-.5 0-.9.4-.9.9V15c0 .6-.7.8-1 .3L9 14c-.4-.6-1.1-.7-1.7-.3L7 14l2 4.9c.1.2.3.3.6.3H15c.2 0 .5-.2.5-.4l1-3.5c.2-.9-.3-1.8-1.2-2.1zm-6.2-2.1V8.5c.1-1.2 1.1-2.2 2.3-2.3h.2c1.3.1 2.2 1.1 2.3 2.3v2.6c0 .2.3.3.4.2.7-.7 1.1-1.7 1.1-2.7 0-2.2-2-4-4.2-3.8C9.4 5 8 6.3 7.7 8c-.2 1.2.2 2.4 1 3.3.2.1.4 0 .4-.2z"
      }
    },
    merge: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.9 17.4c-1.7-.8-2.9-2.3-3.5-3.9-.2-.6-.3-1.3-.4-1.9v-1.1h3.2c.3 0 .5-.3.3-.5l-4.3-5.1c-.1-.2-.4-.2-.6 0L7.5 10c-.2.2 0 .5.2.5H11v1.1c-.1.6-.2 1.3-.4 1.9-.7 1.6-1.8 3.1-3.5 3.9-.3.1-.4.4-.3.6l.4.9c.1.3.4.4.7.2 1.8-.8 3.2-2.2 4.1-3.9.9 1.7 2.3 3.1 4.2 3.9.2.1.5.1.6-.2l.4-.9c.1-.2 0-.5-.3-.6z"
      }
    },
    messaging_conversation: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "fill": "#FFF",
        "d": "M13.1 17.1c2.6-.9 4.1-2.5 4.5-4.7 1.1.5 1.8 1.6 1.8 2.8 0 .6-.1 1.1-.3 1.5l.4 1.3c.1.3-.2.6-.5.5l-1.3-.5c-.5.3-1.1.5-1.7.5-1.2 0-2.2-.6-2.9-1.4zM10.6 5.3c3.2 0 5.8 2.4 5.8 5.4 0 3-2.6 5.4-5.8 5.4-1.1 0-2.2-.3-3-.8-.1-.1-.3-.1-.4-.1l-1.7.6c-.3.1-.6-.1-.5-.5l.6-1.7c0-.1 0-.2-.1-.3-.4-.8-.7-1.7-.7-2.6 0-3 2.6-5.4 5.8-5.4zM7.7 8.9c-.3 0-.5.2-.5.5v.4c0 .3.2.5.5.5h6.2c.3 0 .5-.2.5-.5v-.4c0-.3-.2-.5-.5-.5H7.7zm0 2.6c-.3 0-.5.2-.5.5v.5c0 .2.2.5.5.5H11c.3 0 .5-.3.5-.5V12c0-.3-.2-.5-.5-.5H7.7z"
      }
    },
    messaging_session: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "fill": "#FFF",
        "d": "M12 5.3c4 0 7.2 3 7.2 6.7S16 18.7 12 18.7c-1.4 0-2.7-.3-3.8-1-.1-.1-.2-.1-.4 0l-2.1.7c-.4.1-.7-.2-.6-.6l.7-2.1c0-.1 0-.3-.1-.4-.6-1-.9-2.1-.9-3.3C4.8 8.3 8 5.3 12 5.3zm3.1 5.5c.2 0 .3-.1.3-.2V9.1c0-.1-.1-.2-.3-.2H8.9c-.2 0-.3.1-.3.2v1.5c0 .1.1.2.3.2h6.2zm-4.8 4.8c.2 0 .3-.1.3-.2v-2.9c0-.2-.1-.3-.3-.3H8.9c-.2 0-.3.1-.3.3v2.9c0 .1.1.2.3.2h1.4zm4.8 0c.2 0 .3-.1.3-.2v-2.9c0-.2-.1-.3-.3-.3h-2.9c-.1 0-.2.1-.2.3v2.9c0 .1.1.2.2.2h2.9z"
      }
    },
    messaging_user: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "fill": "#FFF",
        "d": "M12 5.3c4 0 7.2 3 7.2 6.7S16 18.7 12 18.7c-1.4 0-2.7-.3-3.8-1-.1-.1-.2-.1-.4 0l-2.1.7c-.4.1-.7-.2-.6-.6l.7-2.1c0-.1 0-.3-.1-.4-.6-1-.9-2.1-.9-3.3C4.8 8.3 8 5.3 12 5.3zm2.1 10.1c.5 0 .8-.5.8-1 0-.8-.8-1.2-1.6-1.6-.6-.2-.6-.4-.6-.6 0-.3.1-.5.3-.7.4-.3.5-.7.5-1.2 0-.9-.5-1.7-1.5-1.7s-1.5.8-1.5 1.7c0 .5.2.9.5 1.2.2.2.3.4.3.7 0 .2-.1.4-.6.7-.8.3-1.6.7-1.6 1.5 0 .5.4 1 .8 1h4.2z"
      }
    },
    metrics: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 5.3H6.7c-.8 0-1.4.6-1.4 1.4v10.6c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V6.7c0-.8-.6-1.4-1.4-1.4zM9.1 15.8c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-2.6c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v2.6zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5V9.6c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v6.2zm2.4 0c0 .3-.2.5-.5.5H13c-.3 0-.5-.2-.5-.5V8.2c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v7.6zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v4.5z"
      }
    },
    news: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 6.5H7.4c-.2 0-.4.1-.4.4v8.4c0 .3-.3.6-.6.6-.3-.1-.5-.3-.5-.6V9.2c0-.1-.1-.2-.3-.2h-.4c-.2 0-.4.1-.4.4v7c0 .6.5 1.1 1.1 1.1h12.2c.6 0 1.1-.5 1.1-1.1V6.9c0-.3-.2-.4-.4-.4zm-6.2 8c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.2.3-.2h3.3c.1 0 .3.1.3.2v.6zm0-2.2c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.3.3-.3h3.3c.1 0 .3.2.3.3v.6zm4.9 2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.2.2-.2h3.4c.1 0 .2.1.2.2v.6zm0-2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.3.2-.3h3.4c.1 0 .2.2.2.3v.6zm0-2.2c0 .1-.1.2-.2.2H9c-.2 0-.3-.1-.3-.2V8.4c0-.2.1-.3.3-.3h8.3c.1 0 .2.1.2.3v1.7z"
      }
    },
    note: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 16.1l-.3.2c-.2.3-.6.5-1.1.5H15c-.8 0-1.6-.6-1.6-1.6v-.7c0-.6.3-1 .5-1.2l3.2-3.2c.1-.1.2-.3.2-.4V7.2c0-.8-.7-1.4-1.5-1.4H8.2c-.8 0-1.5.7-1.5 1.4h-.5c-.5 0-.9.4-.9 1s.4.9.9.9h.5V11h-.5c-.5 0-.9.5-.9 1s.4 1 .9 1h.5v1.9h-.5c-.5 0-.9.4-.9.9s.4 1 .9 1h.5c0 1 .7 1.4 1.5 1.4h7.6c.8 0 1.5-.6 1.5-1.4v-.6c0-.2-.1-.2-.2-.1zm-2.5-6.7c0 .2-.2.4-.4.4H9.4c-.3 0-.5-.2-.5-.4v-.5c0-.3.2-.5.5-.5h4.8c.2 0 .4.2.4.5v.5zm-2.1 5.7c0 .3-.2.5-.5.5H9.4c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4H12c.3 0 .5.2.5.4v.5zm.7-2.9c0 .3-.2.5-.5.5H9.4c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h3.3c.3 0 .5.2.5.5v.4zm6.3-1.3l-.3-.2c-.1-.2-.4-.2-.6 0l-3.7 3.7v.8c0 .1 0 .2.1.2h.7c.1 0 .1-.1.1-.1l3.7-3.7c.2-.2.2-.5 0-.7z"
      }
    },
    omni_supervisor: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.1 6.9c-1.5.7-2.3 2.2-2.4 4.6h2.4c.3-.8 1-1.4 1.9-1.4 1.1 0 1.9.8 1.9 1.9s-.8 1.9-1.9 1.9c-.9 0-1.6-.6-1.9-1.4h-2.4c.1 2.4.9 3.9 2.4 4.6.2-.9 1-1.5 1.9-1.5 1.1 0 1.9.9 1.9 1.9s-.8 1.9-1.9 1.9c-.9 0-1.6-.5-1.8-1.3-2.2-.7-3.4-2.6-3.5-5.6h-1.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.4c.1-3 1.3-4.9 3.5-5.6.2-.8.9-1.3 1.8-1.3 1.1 0 1.9.8 1.9 1.9s-.8 1.9-1.9 1.9c-.9 0-1.7-.6-1.9-1.5zm1.9.5c.5 0 1-.4 1-.9s-.5-1-1-1-1 .4-1 1 .5.9 1 .9zm0 11.1c.5 0 1-.4 1-1s-.5-.9-1-.9-1 .4-1 .9.5 1 1 1zm0-5.5c.5 0 1-.5 1-1s-.5-1-1-1-1 .5-1 1 .5 1 1 1zm-7.2 3.3H5.4c-.6 0-1.1-.6-1.1-1.2.1-1 1.1-1.5 2.1-1.9.7-.3.8-.6.8-.9 0-.3-.2-.6-.4-.8-.4-.4-.7-1-.7-1.6 0-1.2.8-2.2 2-2.2 1.3 0 2 1 2 2.2 0 .6-.2 1.2-.6 1.6-.3.2-.4.5-.4.8 0 .3.1.6.8.9 1 .4 2 .9 2.1 1.9-.1.6-.6 1.2-1.2 1.2z"
      }
    },
    operating_hours: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12.7 12a.3.3 0 0 1-.1-.2v-2a.3.3 0 0 0-.3-.3h-.6a.3.3 0 0 0-.3.3v2.5a.4.4 0 0 0 .1.3l1.5 1.5a.3.3 0 0 0 .5 0l.4-.4a.3.3 0 0 0 0-.5zM12 6.9a5.1 5.1 0 1 0 5.1 5.1A5.1 5.1 0 0 0 12 6.9zm0 8.9a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8zm-5.1-1.4a3.8 3.8 0 0 1 0-4.8l-.8-1a5 5 0 0 0 0 6.7zm10.2-4.8a3.8 3.8 0 0 1 0 4.8l.8 1a5 5 0 0 0 0-6.7z",
        "fill-rule": "evenodd"
      }
    },
    opportunity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 16.6H6.9c-.2 0-.4.2-.4.4 0 .8.6 1.5 1.4 1.5h8.2c.8 0 1.4-.7 1.4-1.5 0-.2-.2-.4-.4-.4zm1.1-9.9c-.8 0-1.4.7-1.4 1.5 0 .4.2.8.5 1.1-.4.9-1.3 1.5-2.4 1.5-1.3-.1-2.3-1.1-2.4-2.4v-.6c.6-.2.9-.7.9-1.3 0-.8-.6-1.5-1.4-1.5s-1.4.7-1.4 1.5c0 .6.3 1.1.9 1.3v.6c-.1 1.3-1.1 2.3-2.4 2.4-1.1.1-2-.6-2.4-1.5.3-.3.5-.7.5-1.1 0-.8-.6-1.5-1.4-1.5s-1.5.7-1.5 1.5.7 1.4 1.5 1.4l.6 5.1c.1.3.2.4.5.4h10.2c.2 0 .4-.1.5-.4l.6-5.1c.8 0 1.5-.6 1.5-1.4s-.7-1.5-1.5-1.5z"
      }
    },
    opportunity_splits: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M16.6 6.5c-1.2-1.1-2.8-1.7-4.6-1.7C8 4.8 4.8 8 4.8 12c0 1.8.6 3.4 1.7 4.6L16.6 6.5zM8.2 18.1c1.1.7 2.4 1.1 3.8 1.1 4 0 7.2-3.2 7.2-7.2 0-1.4-.4-2.7-1.1-3.8l-9.9 9.9z"
      }
    },
    orders: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 14.9l-.9-.4c-.1-.1-.2-.1-.4 0l-5.1 2.4c-.3.2-.7.2-1 0l-5.1-2.4c-.2-.1-.3-.1-.4 0l-.9.4c-.4.2-.4.7 0 .9l6.4 3c.3.2.7.2 1 0l6.4-3c.4-.2.4-.7 0-.9zm0-3.4l-.9-.4h-.4l-5.1 2.5c-.3.1-.7.1-1 0l-5.1-2.5H6l-.9.4c-.4.2-.4.7 0 .9l6.4 3.1c.3.1.7.1 1 0l6.4-3c.4-.2.4-.8 0-1zM5.1 9.1l6.4 3c.3.2.7.2 1 0l6.4-3c.4-.2.4-.7 0-.9l-6.4-3.1c-.3-.1-.7-.1-1 0L5.1 8.2c-.4.2-.4.7 0 .9z"
      }
    },
    partner_fund_allocation: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.4 15.7l-1.9 2.1c-.1.1-.2 0-.2-.1v-.9c0-.1-.1-.3-.2-.3h-.4c-.1 0-.2.2-.2.3V19c0 .2.1.2.2.2H7c.1 0 .2 0 .2-.2v-.3c0-.1-.1-.2-.2-.2H6c-.1 0-.1-.1 0-.2l2.4-2.6h-1zm10.1 2.6c.1.1.1.2-.1.2h-.9c-.1 0-.2.1-.2.2v.3c0 .1.1.2.2.2h2.3c.1 0 .1 0 .1-.1v-2.3c0-.1 0-.2-.1-.2h-.4c-.1 0-.2.1-.2.2v.9c0 .1-.1.2-.2.1l-1.1-1c-.3.1-.6.1-.8.2l1.4 1.3zm-1-8.6C12.9 10.8 10 7.4 6 9c-.3.1-.5.4-.5.8v4.1c0 .6.5.9 1 .8 4-1.2 6.8 2.2 10.6.7.3-.2.5-.4.5-.8v-4.1c0-.5-.6-.9-1.1-.8zm-4.8 3.9c-.9 0-1.6-.7-1.6-1.6s.7-1.5 1.6-1.5 1.5.7 1.5 1.5-.7 1.6-1.5 1.6zm-.1-7.2c0-.1-.1-.2-.2-.1l-.6.7c-.1.1-.3 0-.3 0l-.3-.3v-.2l1.7-1.7h.2l1.6 1.7c.1 0 .1.1.1.2l-.3.3h-.3l-.6-.7c-.1-.1-.2 0-.2.1v1.7l-.8-.2V6.4z"
      }
    },
    partner_fund_claim: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.6 8.2h2.2c.2 0 .3-.2.3-.4v-.2l-2.9-2.7c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.2c0 .5.4.9.9.9zm-4.3 7.4c0-.8.4-1.6 1.2-1.9.6-.2 1.3-.4 1.9-.4 1 0 1.8.3 2.6.5.4.1.7.3 1.1.3l.1-4.3c0-.2-.2-.4-.5-.4h-3c-.7 0-1.2-.6-1.2-1.2v-3c0-.2-.2-.4-.5-.4H6.8c-.7 0-1.3.6-1.3 1.2v10.1c0 .7.6 1.3 1.3 1.3h2.5v-1.8zm8.1 0c-2.2.6-3.9-1.4-6.3-.4-.2 0-.3.2-.3.4v2.5c0 .3.3.5.6.4 2.4-.7 4.1 1.4 6.3.4.2 0 .3-.2.3-.4V16c0-.3-.3-.5-.6-.4zm-2.9 2.3c-.5 0-1-.4-1-.9s.4-1 1-1 .9.4.9 1-.4.9-.9.9z"
      }
    },
    partner_fund_request: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.5 14c.9-.5 1.7-.8 2.7-.8.2 0 .5.1.7.1.1 0 .2 0 0-.1-.4-.3-.9-.5-1.4-.7-1.1-.5-1.2-.8-1.2-1.3 0-.4.3-.8.6-1.1.6-.5.9-1.3.9-2.2 0-1.6-1-3.1-2.8-3.1S7.1 6.3 7.1 7.9c0 .9.3 1.7.9 2.2.4.3.7.7.7 1.1 0 .4-.2.8-1.2 1.3-1.5.6-2.9 1.3-2.9 2.7 0 .9.6 1.7 1.5 1.7h3.4c.2 0 .5-.2.5-.5v-1.6c0-.3.2-.6.5-.8zm7.8 1.4c-2.2.7-4-1.4-6.5-.4-.2.1-.3.2-.3.5V18c0 .4.3.6.6.5 2.4-.8 4.2 1.4 6.5.4.2-.1.4-.2.4-.4v-2.6c0-.3-.4-.6-.7-.5zm-3 2.4c-.5 0-1-.4-1-.9s.5-1 1-1 .9.4.9 1-.4.9-.9.9z"
      }
    },
    partner_marketing_budget: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.7 9.1c-4.4 1.3-7.8-2.8-12.6-.9-.3.2-.5.5-.5.9v5c0 .6.5 1.1 1.1.9 4.7-1.5 8.2 2.7 12.6.8.4-.1.6-.4.6-.9V10c.1-.6-.6-1.1-1.2-.9zm-5.8 4.6c-1 0-1.8-.8-1.8-1.8s.8-1.9 1.8-1.9 1.9.9 1.9 1.9-.9 1.8-1.9 1.8z"
      }
    },
    partners: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.5 7.6H17c-.3 0-.6-.1-.8-.4L15 6.3c-.2-.2-.5-.4-.8-.4h-2.8c-.4 0-.7.2-1 .4L8.9 7.6c-.1.1-.1.2 0 .4l.4.4c.3.2.8.3 1.1.1l1.3-.8c.2-.1.4-.1.5.1l4.2 4c.1.1.2.2.2.4v1c0 .3.2.6.4.6h1.5c.2 0 .5-.2.5-.5V8.1c0-.3-.3-.5-.5-.5zm-4.1 4.3l-2.6-2.5-.7.4c-.4.3-.8.4-1.2.4-.5 0-1-.2-1.4-.6l-1-.7c-.2-.2-.3-.4-.3-.6-.1-.3-.3-.5-.5-.5H5c-.2 0-.4.2-.4.5v4.3c0 .3.2.5.4.5h1c.1 0 .2-.2.3-.4.3-.4.9-.7 1.4-.8.6 0 1.2.2 1.6.6l3 2.7c.3.3.5.5.6.9.1.1.3.2.4.1l1.1-1.2c.6-.6 1-1.9.5-2.5l-.5-.6zm-6 1.8c-.3-.3-.8-.2-1 .1-.3.3-.2.8.1 1.1l3 2.7c.1.2.3.2.5.2s.4-.1.5-.3c.2-.3.2-.8-.1-1.1l-3-2.7zm10.5 4.4"
      }
    },
    past_chat: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 5.3c-4 0-7.2 2.9-7.2 6.5 0 1.2.3 2.3.8 3.2.1.2.2.4.1.5l-.9 2.6c-.1.2.1.5.4.4l2.6-1c.1-.1.3 0 .5.1 1.1.6 2.4.9 3.8.9 3.9 0 7.1-2.9 7.1-6.6 0-3.7-3.2-6.6-7.2-6.6zm2.8 9.7l-.3.3c-.2.2-.4.2-.6.2s-.3 0-.5-.2L11 13c-.1-.1-.2-.4-.2-.7V9c0-.4.3-.7.7-.7h.5c.4 0 .7.3.7.7v3l2 2c.1.1.2.3.2.5s-.1.3-.2.5z"
      }
    },
    people: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8.9 0 1.8-.3 2.6-.8.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
      },
      "ellipse": {
        "cx": "12",
        "cy": "8.76",
        "rx": "3.576",
        "ry": "3.96"
      }
    },
    performance: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.2 4.8h-.5c-.8 0-1.4.7-1.4 1.4v11.6c0 .7.6 1.4 1.4 1.4h.5c.3 0 .5-.2.5-.5V5.3c0-.3-.2-.5-.5-.5zm10.1 0H9.6c-.3 0-.5.2-.5.5v13.4c0 .3.2.5.5.5h7.7c.8 0 1.4-.6 1.4-1.4V6.2c0-.8-.6-1.4-1.4-1.4zm-.5 6.4l-1.3 1.3v.1l.2 1.8c.1.2-.1.3-.2.2l-1.5-.8c-.1-.1-.1-.1-.2 0l-1.5.8c-.2.1-.3 0-.3-.2l.3-1.8v-.1L11 11.2c-.1-.1 0-.2.1-.2l1.7-.3c.1 0 .1 0 .2-.1l.7-1.6c.1-.2.2-.2.3 0l.8 1.6c0 .1 0 .1.1.1l1.7.3c.2 0 .2.1.2.2z"
      }
    },
    person_account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M16.7 14.2c-.9-.4-1-.7-1-1.1 0-.4.2-.7.5-1 .5-.4.8-1.1.8-1.8 0-1.4-.9-2.6-2.5-2.6s-2.4 1.2-2.4 2.6c0 .7.3 1.4.8 1.8.3.3.5.6.5 1s-.1.7-1 1.1c-1.3.5-2.5 1.2-2.5 2.3 0 .8.6 1.5 1.3 1.5h6.7c.7 0 1.3-.7 1.3-1.5 0-1.1-1.2-1.8-2.5-2.3zm-5.8 1.1"
      }, {
        "d": "M11.2 12.3c-.1-.1-.6-.7-.5-2.3 0-1.6.7-2 .7-2V6.5c0-.3-.3-.5-.5-.5H5.3s-.5.2-.5.5v10.4H8c.1-2.6 3.2-3.7 3.2-3.7.4-.2.1-.7 0-.9zm-3.8 3.3c0 .3-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.3 0 .5.2.5.4v.5zm0-2.4c0 .3-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.3 0 .5.2.5.5v.4zm0-2.3c0 .2-.2.5-.5.5h-.5c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm0-2.4c0 .3-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5V8c0-.2.2-.5.5-.5h.5c.3 0 .5.3.5.5v.5zm2.7 4.7c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.4zm0-2.3c0 .2-.3.5-.5.5h-.5c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.5zm0-2.4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5V8c0-.2.2-.5.5-.5h.5c.2 0 .5.3.5.5v.5z"
      }]
    },
    photo: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.6 7.4h6.8c.2 0 .3-.2.2-.3l-.8-1.2c-.3-.5-.8-.8-1.3-.8h-3c-.5 0-1 .3-1.3.8l-.8 1.2c-.1.1 0 .3.2.3zm3.4 4.4c-1.1 0-1.9.8-1.9 1.9s.8 1.9 1.9 1.9 1.9-.9 1.9-1.9-.8-1.9-1.9-1.9zm5.8-2.9H6.2c-.8 0-1.4.6-1.4 1.4V17c0 .8.6 1.5 1.4 1.5h11.6c.8 0 1.4-.7 1.4-1.5v-6.7c0-.8-.6-1.4-1.4-1.4zM12 17c-1.8 0-3.4-1.5-3.4-3.3s1.6-3.4 3.4-3.4 3.4 1.5 3.4 3.4S13.8 17 12 17z"
      }
    },
    poll: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.2 4.8H5.8c-.6 0-1 .4-1 1v1.9c0 .5.4.9 1 .9h12.4c.6 0 1-.4 1-.9V5.8c0-.6-.4-1-1-1zm-6 2.9V5.8h6v1.9h-6zm6 2.4H5.8c-.6 0-1 .4-1 .9v2c0 .5.4.9 1 .9h12.4c.6 0 1-.4 1-.9v-2c0-.5-.4-.9-1-.9zM10.1 13v-2h8.1v2h-8.1zm8.1 2.4H5.8c-.6 0-1 .4-1 .9v1.9c0 .6.4 1 1 1h12.4c.6 0 1-.4 1-1v-1.9c0-.5-.4-.9-1-.9zm-3.8 2.8v-1.9h3.8v1.9h-3.8z"
      }
    },
    portal: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 5.3H6.7c-.8 0-1.4.6-1.4 1.4v10.6c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V6.7c0-.8-.6-1.4-1.4-1.4zM14.2 15c0 .3-.2.6-.5.6h-3.4c-.3 0-.5-.3-.4-.6l.7-2.6c-.7-.5-1.1-1.5-1-2.5.2-1 1-1.7 1.9-1.9 1.6-.3 2.9.9 2.9 2.4 0 .8-.4 1.5-1 2l.8 2.6z"
      }
    },
    post: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 5.2c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3.1.4l-.7 2.1c-.1.4.2.8.6.6l2.1-.7c.2-.1.3 0 .4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7s-3.2-6.7-7.2-6.7z"
      }
    },
    pricebook: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2 4.8h-9c-.8 0-1.5.7-1.5 1.4v.5h-.5c-.5 0-.9.5-.9 1s.4.9.9.9h.5V11h-.5c-.5 0-.9.5-.9 1s.4 1 .9 1h.5v2.4h-.5c-.5 0-.9.4-.9.9s.4 1 .9 1h.5v.4c0 .7.7 1.5 1.5 1.5h9c.8 0 1.5-.8 1.5-1.6V6.1c0-.8-.7-1.3-1.5-1.3zm-6.9 9.8c0 .2-.1.3-.2.3h-1c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h1c.1 0 .2.1.2.3v5.2zm1.9 0c0 .2-.1.3-.2.3h-.5c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h.5c.1 0 .2.1.2.3v5.2zm2.4 0c0 .2-.1.3-.2.3h-1c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h1c.1 0 .2.1.2.3v5.2zm2 0c0 .2-.1.3-.3.3h-.5c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h.5c.2 0 .3.1.3.3v5.2z"
      }
    },
    process: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9 11.1l2.6-3.2c.2-.2.6-.2.8 0l2.6 3.2c0 .1.2.2.3.2h2.9c.3 0 .5-.2.5-.5V6.7c0-.8-.6-1.4-1.4-1.4H6.7c-.8 0-1.4.6-1.4 1.4v4.1c0 .3.2.5.5.5h2.8c.2 0 .3-.1.4-.2zm6 1.8l-2.6 3.2c-.2.2-.6.2-.8 0L9 12.9c-.1-.1-.2-.2-.4-.2H5.8c-.3 0-.5.2-.5.5v4.1c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4v-4.1c0-.3-.2-.5-.5-.5h-2.9c-.1 0-.3.1-.3.2z"
      }
    },
    product: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.3 15.8h1.2c.2 0 .5-.2.5-.4V7.9c0-.2-.3-.5-.5-.5H5.3c-.3 0-.5.3-.5.5v7.5c0 .2.2.4.5.4zm13.4-8.4h-1.2c-.2 0-.5.3-.5.5v7.5c0 .2.3.4.5.4h1.2c.3 0 .5-.2.5-.4V7.9c0-.2-.2-.5-.5-.5zm-6 8.4c.3 0 .5-.2.5-.4V7.9c0-.2-.2-.5-.5-.5h-1.4c-.3 0-.5.3-.5.5v7.5c0 .2.2.4.5.4h1.4zm2.9 0c.3 0 .5-.2.5-.4V7.9c0-.2-.2-.5-.5-.5h-.5c-.2 0-.5.3-.5.5v7.5c0 .2.3.4.5.4h.5zm-6.2 0c.2 0 .4-.2.4-.4V7.9c0-.2-.2-.5-.4-.5h-.5c-.3 0-.5.3-.5.5v7.5c0 .2.2.4.5.4h.5zm9.3 1.5H5.3c-.3 0-.5.2-.5.5v.4c0 .3.2.5.5.5h13.4c.3 0 .5-.2.5-.5v-.4c0-.3-.2-.5-.5-.5zm0-12.5H5.3c-.3 0-.5.2-.5.5v.5c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4v-.5c0-.3-.2-.5-.5-.5z"
      }
    },
    product_consumed: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.5 13.2h-.9a.5.5 0 0 0-.4.5v3a.5.5 0 0 1-.5.4H6.8a.5.5 0 0 1-.4-.4v-3a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.4.5v4a1.2 1.2 0 0 0 1.2 1.2h12a1.2 1.2 0 0 0 1.2-1.2v-4a.5.5 0 0 0-.5-.5zm-7 2a.4.4 0 0 0 .6 0l4-4a.4.4 0 0 0 0-.7l-.6-.6a.4.4 0 0 0-.6 0l-1.7 1.7a.3.3 0 0 1-.5-.2V5a.5.5 0 0 0-.5-.5h-.9a.5.5 0 0 0-.4.5v6.4a.3.3 0 0 1-.5.2L8.7 9.9a.4.4 0 0 0-.7 0l-.6.6a.4.4 0 0 0 0 .7z"
      }
    },
    product_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "rect": [{
        "x": "4.56",
        "y": "4.541",
        "width": "14.4",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "9.821",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "15.101",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "12.48",
        "y": "9.821",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "12.48",
        "y": "15.101",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }]
    },
    product_item_transaction: {
      "xmlns": "http://www.w3.org/2000/svg",
      "rect": [{
        "x": "4.56",
        "y": "4.541",
        "width": "14.4",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "9.821",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "15.101",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }],
      "path": {
        "d": "M15.6 17.4a.3.3 0 0 0 .5 0l2.8-2.7a.3.3 0 0 0 0-.5l-2.8-2.8a.3.3 0 0 0-.5 0l-.5.5a.3.3 0 0 0 0 .5l.8.9a.2.2 0 0 1-.1.4h-2.9a.4.4 0 0 0-.4.3v.8a.4.4 0 0 0 .4.3h2.9a.2.2 0 0 1 .1.4l-.8.9a.3.3 0 0 0 0 .5z"
      }
    },
    product_request: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M18.6 18.7H9.7c-.3 0-.5-.2-.5-.5v-1.1c0-.3.2-.6.5-.6h8.9c.3 0 .5.3.5.6v1.1c.1.3-.2.5-.5.5zm-12.2 0H5.3c-.3 0-.6-.2-.6-.5v-1.1c0-.3.3-.6.6-.6h1.1c.3 0 .5.3.5.6v1.1c.1.3-.2.5-.5.5zm6.5-4.9c-.3 0-.5-.2-.5-.5v-1.1c0-.3.2-.6.5-.6h5.7c.3 0 .5.3.5.5v1.2c0 .3-.2.5-.5.5h-5.7zM15 8.9c-.3 0-.5-.2-.5-.5V7.2c0-.2.2-.5.5-.5h3.6c.3 0 .5.2.5.5v1.2c0 .2-.2.5-.5.5H15zM5 14c-.3-2.6 1.7-5.3 4.1-5.7l.7-.2c.1 0 .2-.1.2-.3l-.1-.1-1.6-1.1c-.2-.1-.2-.3-.1-.5l.4-.6c.1-.1.3-.2.5-.1L13 8c.1.1.2.4.1.5l-2.7 3.9c-.1.2-.3.2-.5.1l-.6-.4c-.2-.1-.2-.3-.1-.5l1.1-1.6c0-.1 0-.3-.1-.3 0-.1-.1-.1-.2-.1l-.4.1c-1.8.4-3.4 2.5-3.2 4.3 0 .2-.3.4-.5.4h-.5c-.2.1-.4-.2-.4-.4z"
      }
    },
    product_request_line_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M18.7 18.6H9.8c-.3 0-.6-.3-.6-.6v-1.1c0-.3.3-.5.6-.5h8.8c.3 0 .6.2.6.5V18c0 .3-.2.6-.5.6zm-12.2 0H5.4c-.3 0-.6-.3-.6-.6v-1.1c0-.3.2-.5.5-.5h1.2c.2 0 .5.2.5.5V18c0 .3-.2.6-.5.6zm-.6-7c1.6-2.8 5.5-4 8-2.8l.7.3c.3.1.5-.1.4-.4l-.6-2.2c-.1-.3 0-.5.2-.6l.9-.3c.1-.1.4 0 .5.2v.1l1.6 5.4c.1.2 0 .5-.3.6l-5.3 2c-.1.1-.4 0-.5-.1v-.1l-.2-.9c-.1-.2 0-.5.2-.5l2.2-.9c.2 0 .2-.2.2-.4 0-.1-.1-.1-.1-.2l-.5-.1c-1.9-1-5 0-6.2 2-.1.2-.5.2-.8.1l-.4-.4c-.2-.1-.2-.5 0-.8z"
      }
    },
    product_required: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "rect": [{
        "x": "10.543",
        "y": "16.385",
        "width": "8.657",
        "height": "1.918",
        "rx": ".48",
        "ry": ".48"
      }, {
        "x": "10.543",
        "y": "12.101",
        "width": "8.657",
        "height": "1.918",
        "rx": ".48",
        "ry": ".48"
      }, {
        "x": "11.981",
        "y": "7.817",
        "width": "7.219",
        "height": "1.918",
        "rx": ".48",
        "ry": ".48"
      }],
      "path": [{
        "d": "M8.1 18.3h-.9a.5.5 0 0 1-.5-.5v-.9a.5.5 0 0 1 .5-.5h.9a.5.5 0 0 1 .5.5v.9a.5.5 0 0 1-.5.5zm0-4.3h-.9a.5.5 0 0 1-.5-.5v-.9a.5.5 0 0 1 .5-.5h.9a.5.5 0 0 1 .5.5v.9a.5.5 0 0 1-.5.5z",
        "fill-rule": "evenodd"
      }, {
        "d": "M11.4 6.3l-.5-.5a.3.3 0 0 0-.5 0L7.2 9 5.9 7.7a.3.3 0 0 0-.5 0l-.5.5a.3.3 0 0 0 0 .5l1.8 1.8a.7.7 0 0 0 1 0l3.7-3.7a.4.4 0 0 0 0-.5z",
        "fill-rule": "evenodd"
      }]
    },
    product_return: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M5.3 5.4h8.8c.3 0 .6.2.6.5V7c0 .3-.3.6-.5.6H5.3c-.3 0-.6-.3-.6-.6V5.9c0-.3.2-.5.6-.5zm12.2 0h1.1c.3 0 .5.2.5.5V7c0 .3-.2.6-.5.6h-1.1c-.3 0-.6-.3-.6-.6V5.9c0-.3.2-.5.5-.5h.1zm-6.6 4.9c.3 0 .6.2.6.5v1.1c0 .3-.2.6-.5.6H5.3c-.3 0-.6-.3-.6-.5v-1.2c0-.3.3-.5.6-.5h5.6zm-2.1 4.9c.3 0 .6.2.6.5v1.1c0 .3-.3.6-.5.6H5.3c-.3 0-.6-.2-.6-.5v-1.2c0-.2.3-.5.6-.5h3.5zm10.1-5.1c.3 2.6-1.8 5.3-4.2 5.7l-.6.2c-.1 0-.2.1-.2.2s0 .2.1.2l1.6 1.1c.2.1.2.3.1.5l-.4.6c-.1.1-.4.2-.5.1l-3.9-2.6c-.2-.1-.2-.4-.1-.5l2.6-3.9c.1-.2.4-.3.5-.1l.6.4c.2.1.3.3.1.5l-1 1.6c-.1.1-.1.3 0 .3.1.1.2.1.2.1l.4-.1c1.9-.4 3.5-2.5 3.3-4.3 0-.2.3-.4.5-.5h.4c.2 0 .5.3.5.5z"
      }
    },
    product_return_line_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M5.3 5.5h8.9c.3 0 .6.3.6.6v1.1c0 .3-.3.6-.6.6H5.4c-.3 0-.6-.3-.6-.6V6.1c0-.3.2-.6.5-.6zm12.2 0h1.1c.3 0 .6.3.6.6v1.1c0 .3-.2.6-.5.6h-1.2c-.2 0-.5-.3-.5-.6V6.1c0-.3.2-.5.5-.6zm.6 7c-1.6 2.8-5.5 4.1-8 2.8l-.7-.3c-.3-.1-.5.1-.4.4l.6 2.2c.1.3 0 .5-.2.6l-.9.3c-.1.1-.4 0-.5-.2l-1.6-5.5c-.1-.2 0-.5.3-.6l5.3-2c.1-.1.4 0 .5.2l.2.9c.1.2 0 .5-.2.6l-2.2.8c-.2.1-.2.2-.2.4 0 .1.1.1.1.2l.5.2c1.9.9 5-.1 6.2-2.1.1-.1.5-.2.8-.1l.4.4c.2.1.2.6 0 .8z"
      }
    },
    product_transfer: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.1 4.9h-.8a.4.4 0 0 0-.4.5v1.9c0 .3-.3.5-.5.3a6.2 6.2 0 0 0-5.3-2.1 5.5 5.5 0 0 0-2.1.6 5.5 5.5 0 0 0-1 .6.5.5 0 0 0 0 .7l.6.6a.4.4 0 0 0 .5 0 6.9 6.9 0 0 1 1.1-.6c.2 0 .4-.1.6-.1a4.7 4.7 0 0 1 4.5 1.5c.3.4 0 .7-.2.7h-2a.5.5 0 0 0-.5.4v.8a.5.5 0 0 0 .5.5h5.1a.4.4 0 0 0 .4-.4V5.4a.4.4 0 0 0-.5-.5zM15.6 15a.4.4 0 0 0-.6 0 4.5 4.5 0 0 1-1.7 1c-.2.1-.3.1-.5.2a4.7 4.7 0 0 1-4.5-1.5c-.3-.4-.1-.7.2-.7h2a.4.4 0 0 0 .4-.4v-.9a.4.4 0 0 0-.4-.4H5.3a.4.4 0 0 0-.4.4v5.4a.4.4 0 0 0 .5.4h.8a.4.4 0 0 0 .5-.4v-2c0-.2.2-.4.4-.2a6.2 6.2 0 0 0 5.3 2.1 5.5 5.5 0 0 0 2.1-.7 6.2 6.2 0 0 0 1.6-1.1.4.4 0 0 0 0-.6z"
      }
    },
    question_best: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "g": {
        "path": [{
          "d": "M24 24v-9.1L14.9 24H24zm-.9-3.5l-.8.8v.1l.2 1.1s-.1.1-.2.1l-.9-.5c0-.1 0-.1 0 0l-1 .5c-.1 0-.1-.1-.1-.1l.1-1.1v-.1l-.7-.8c-.1 0 0-.1 0-.1l1.1-.2.5-1c0-.1.1-.1.2 0l.4 1h.1l1 .2c.1 0 .1.1.1.1z",
          "fill-opacity": ".65"
        }, {
          "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3 0 .4l-.6 2.1c-.2.4.2.7.6.6l2.1-.7c.1-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm.7 10.8c0 .2-.2.5-.5.5h-.5c-.2 0-.4-.3-.4-.5v-.5c0-.3.2-.5.4-.5h.5c.3 0 .5.2.5.5v.5zm.2-3.1c-.1.1-.2.2-.2.3v.4c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.4c0-.7.5-1.4 1.2-1.6.2-.1.5-.3.6-.5.8-1 0-2.3-1.1-2.3-.4 0-.7.1-1 .4-.2.2-.4.4-.4.7-.1.2-.3.3-.5.3h-.5c-.3 0-.5-.2-.5-.5.2-.6.4-1.1.9-1.5.5-.6 1.3-.9 2-.9 1.6.1 2.8 1.3 2.9 2.8 0 1.3-.8 2.4-2 2.8z"
        }]
      }
    },
    question_feed: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3.1.4l-.7 2.1c-.1.4.2.7.6.6l2.1-.7c.2-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm.7 10.8c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm.2-3.1c-.1.1-.2.2-.2.3v.4c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.4c0-.7.5-1.4 1.2-1.6.2-.1.5-.3.6-.5.8-1 0-2.3-1.1-2.3-.4 0-.7.1-1 .4-.2.2-.4.4-.4.7-.1.2-.3.3-.5.3h-.5c-.3 0-.5-.2-.5-.5.2-.6.4-1.1.9-1.5.5-.6 1.3-.9 2-.9 1.6.1 2.8 1.3 2.9 2.8 0 1.3-.8 2.4-2 2.8z"
      }
    },
    quick_text: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 5.2c-4 0-7.2 2.9-7.2 6.5 0 1.2.3 2.3.9 3.2.1.2.1.4 0 .5L4.7 18c-.1.2.1.5.4.4l2.6-1c.1-.1.3 0 .5.1 1.1.6 2.4.9 3.8.9 3.9 0 7.1-2.9 7.1-6.6 0-3.7-3.2-6.6-7.2-6.6zm-3.4 6.3c0-.1.2-.3.3-.3h4.7c.1 0 .3.2.3.3v.6c0 .1-.1.3-.3.3H8.8c-.1 0-.3-.2-.3-.3v-.6zm6.7 2.8c0 .1-.1.3-.2.3H8.8c-.1 0-.3-.1-.3-.3v-.5c0-.2.1-.3.3-.3H15c.1 0 .2.1.2.3v.5zm0-4.5c0 .2-.1.3-.2.3H8.8c-.1 0-.3-.1-.3-.3v-.5c0-.2.1-.3.3-.3H15c.1 0 .2.1.2.3v.5z"
      }
    },
    quip: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19.1 17.9l-1.2 1.2c-.1.1-.4.1-.5 0L12 13.7V12h1.7l1.6 1.6V8.7H8.7v6.6H12l2.4 2.4H7.1c-.5 0-.8-.3-.8-.8V7.1c0-.5.3-.8.8-.8h9.8c.5 0 .9.3.9.8V16l1.3 1.4c.1.1.1.4 0 .5z"
      }
    },
    quip_sheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 9.3H5.3c-.3 0-.5.2-.5.5v7.6c0 .7.5 1.2 1.2 1.2h1.7c.2 0 .4-.2.4-.4V9.8c0-.3-.2-.5-.4-.5zm11 0h-9c-.2 0-.4.2-.4.5v8.4c0 .2.2.4.4.4H18c.7 0 1.2-.5 1.2-1.2V9.7c0-.2-.2-.4-.5-.4zM18 5.4H6c-.7 0-1.2.5-1.2 1.2v1.1c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4V6.6c0-.6-.5-1.2-1.2-1.2z"
      }
    },
    quotes: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 5.3H12c-.3 0-.6.1-.8.4l-6.5 6.4c-.5.6-.5 1.5 0 2.1l5.1 5c.6.6 1.5.6 2.1 0l6.5-6.5c.2-.2.3-.6.3-.9V6.7c0-.8-.6-1.4-1.4-1.4zm-5.2 10.5l-.3.4c-.2.2-.5.2-.7 0l-3.3-3.3c-.2-.2-.2-.5 0-.7l.4-.3c.2-.2.4-.2.6 0l3.3 3.3c.2.2.2.4 0 .6zm1.9-1.9l-.3.4c-.2.1-.5.1-.7 0L9.7 11c-.1-.2-.1-.5 0-.7l.4-.3c.2-.2.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7zm1.4-4.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.6 1.2 1.2-.6 1.2-1.2 1.2z"
      }
    },
    recent: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 11.5v.5H5.3v-.5h1.4zm5.7-2.9h-.8c-.2 0-.3.2-.3.4v3.1c0 .1 0 .2.1.3l2 2c.1.2.4.2.5 0l.5-.5c.1-.1.1-.3 0-.5l-1.7-1.7V9c0-.2-.1-.4-.3-.4zM12 5.3c-3.6 0-6.5 2.7-6.7 6.2v.3H4.2c-.3 0-.5.3-.3.5l1.8 2.2c.2.2.4.2.6 0l1.8-2.2c.2-.2 0-.5-.3-.5H6.7v-.3C7 8.8 9.2 6.7 12 6.7c3.1 0 5.6 2.7 5.2 5.9-.2 2.3-2.4 4.4-4.7 4.7-1.7.1-3.3-.5-4.4-1.7-.2-.2-.3-.3-.5 0l-.6.6c-.1.2 0 .3.1.4 1.3 1.4 3.1 2.1 5 2.1 3.4 0 6.3-2.8 6.6-6.2.3-3.9-2.8-7.2-6.7-7.2z"
      }
    },
    record: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.4 7.7h5.2c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5zM17.3 6h-.5c-.1 0-.2.1-.2.2v1c0 1.1-.9 1.9-2 1.9H9.4c-1.1 0-2-.8-2-1.9v-1c0-.1-.1-.2-.2-.2h-.5c-.8 0-1.4.6-1.4 1.4v10.4c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V7.4c0-.8-.6-1.4-1.4-1.4zM9.4 16.3c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .5.2.5.4v.5zm0-2.4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .5.2.5.4v.5zm0-2.4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h.5c.2 0 .5.2.5.4v.5zm6.7 4.8c0 .3-.2.5-.5.5h-4.8c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h4.8c.3 0 .5.2.5.4v.5zm0-2.4c0 .3-.2.5-.5.5h-4.8c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h4.8c.3 0 .5.2.5.4v.5zm0-2.4c0 .3-.2.5-.5.5h-4.8c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h4.8c.3 0 .5.2.5.4v.5z"
      }
    },
    related_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 4.8h-7.7c-.8 0-1.5.6-1.5 1.4v.3c0 .1.1.2.3.2h6.9c.8 0 1.5.7 1.5 1.5v7.4c0 .1.1.2.2.2.9 0 1.7-.7 1.7-1.6v-8c0-.8-.6-1.4-1.4-1.4zM6.7 8.2c-.8 0-1.4.6-1.4 1.4v8.2c0 .8.6 1.4 1.4 1.4h7.7c.8 0 1.4-.6 1.4-1.4V9.6c0-.8-.6-1.4-1.4-1.4H6.7zm1.9 3.3c0 .3-.2.5-.4.5h-.5c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h.5c.2 0 .4.2.4.4v.5zm5.3 0c0 .3-.2.5-.5.5h-3.3c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h3.3c.3 0 .5.2.5.4v.5zm-5.3 2.4c0 .3-.2.5-.4.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .4.2.4.4v.5zm5.3 0c0 .3-.2.5-.5.5h-3.3c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h3.3c.3 0 .5.2.5.4v.5zm-5.3 2.4c0 .3-.2.5-.4.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .4.2.4.4v.5zm5.3 0c0 .3-.2.5-.5.5h-3.3c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h3.3c.3 0 .5.2.5.4v.5z"
      }
    },
    relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 16.8h-.9V15h.9c.2 0 .3-.1.3-.3V6.9c0-.2-.1-.3-.3-.3H9.3c-.2 0-.3.1-.3.3v.9H7.2v-.9c0-1.2.9-2.1 2.1-2.1h7.8c1.2 0 2.1.9 2.1 2.1v7.8c0 1.2-.9 2.1-2.1 2.1zM13.8 9H6c-.7 0-1.2.5-1.2 1.2V18c0 .7.5 1.2 1.2 1.2h7.8c.7 0 1.2-.5 1.2-1.2v-7.8c0-.7-.5-1.2-1.2-1.2z"
      }
    },
    report: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.4 7.7h5.2c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5zM17.3 6h-.5c-.1 0-.2.1-.2.2v1c0 1.1-.9 1.9-2 1.9H9.4c-1.1 0-2-.8-2-1.9v-1c0-.1-.1-.2-.2-.2h-.5c-.8 0-1.4.6-1.4 1.4v10.4c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V7.4c0-.8-.6-1.4-1.4-1.4zm-7 9.8c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-2.4c0-.2.2-.4.5-.4h.4c.3 0 .5.2.5.4v2.4zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v4.5zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-3.6c0-.2.2-.4.5-.4h.4c.3 0 .5.2.5.4v3.6z"
      }
    },
    resource_absence: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm4 9.1l-1.2 1.2-2.9-3-2.8 2.8L8 13.8l2.8-2.8-2.9-2.8L9.1 7l2.8 2.8 2.9-2.9L16 8l-3 3zm-9.8 1.5h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    resource_capacity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm4.2 6.3h-4.4V6.5s1.7-.1 3.2 1.4 1.2 3.2 1.2 3.2zm-10 4.3h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    resource_preference: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm-2.6 8.6a.7.7 0 0 1-.7.6h-.5a.3.3 0 0 1-.2-.2v-3.5a.3.3 0 0 1 .2-.3h.9a.3.3 0 0 1 .3.3zm6.5-.7c0 1.4-1.2 1.5-2.6 1.5-1.3 0-1.7-.4-2.9-.5a.2.2 0 0 1-.3-.2v-3.1a.3.3 0 0 1 .3-.2 1.6 1.6 0 0 0 1.5-1.6v-.9a.3.3 0 0 1 .3-.3h.5a.7.7 0 0 1 .7.7v1.5a.7.7 0 0 0 .7.6h1.1a.7.7 0 0 1 .7.6zm-9.7 2.7h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    resource_skill: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M10.5 10.9a1.4 1.4 0 1 0 2.9 0 1.4 1.4 0 1 0-2.9 0zM12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm4 8.1l-.3.4a.6.6 0 0 1-.5.3.7.7 0 0 1-.2 0l-.8-.3a3.4 3.4 0 0 1-1.1.6l-.2.9a.6.6 0 0 1-.5.5h-.6a.6.6 0 0 1-.6-.5l-.1-.9a2.9 2.9 0 0 1-1.1-.6l-.8.3a.7.7 0 0 1-.2.1.6.6 0 0 1-.5-.3l-.3-.5a.6.6 0 0 1 .1-.8l.7-.5a3 3 0 0 1-.1-.6 2.8 2.8 0 0 1 .1-.6l-.7-.6a.6.6 0 0 1-.1-.7l.3-.5a.6.6 0 0 1 .5-.3.7.7 0 0 1 .2 0l.8.3a3.3 3.3 0 0 1 1.1-.6l.1-.8a.6.6 0 0 1 .6-.5h.6a.6.6 0 0 1 .5.5l.2.8a3.3 3.3 0 0 1 1 .6l.9-.3a.7.7 0 0 1 .2 0 .6.6 0 0 1 .5.3l.3.4a.6.6 0 0 1-.2.8l-.7.5a2.9 2.9 0 0 1 .1.7 2.8 2.8 0 0 1-.1.6l.7.5a.6.6 0 0 1 .2.8zm-9.8 2.5h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    reward: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.2 15.2l-2.8 4-.7-1.9H5.8l2.4-3.4c.5.3 1 .4 1.4.5h.3s.2.1.2.2c.3.2.7.5 1.1.6zm4.6-1.3c-.5.3-1 .4-1.4.5h-.3c-.1 0-.2.1-.3.2-.2.2-.6.5-1 .6l2.8 4 .7-1.9h1.9l-2.4-3.4zM12 7.7c-.9 0-1.7.7-1.7 1.7S11.1 11 12 11s1.7-.7 1.7-1.6-.8-1.7-1.7-1.7zm4.6 1.7c0 .5-.7 1-.9 1.5-.2.5-.1 1.3-.5 1.7-.4.4-1.1.3-1.7.5-.5.2-.9.8-1.5.8s-1-.6-1.5-.8c-.6-.2-1.3-.1-1.7-.5-.4-.4-.3-1.2-.5-1.7s-.9-1-.9-1.5c0-.6.7-1.1.9-1.6.2-.5.1-1.3.5-1.7.4-.3 1.1-.2 1.7-.5.5-.2.9-.8 1.5-.8s1 .6 1.5.8c.6.3 1.3.1 1.7.5.4.4.3 1.2.5 1.7s.9 1 .9 1.6zm-1.5 0c0-1.8-1.4-3.2-3.1-3.2S8.9 7.6 8.9 9.4s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1z"
      }
    },
    rtc_presence: {
      "path": {
        "d": "M14.8 4.7c-2.7 0-4.9 2.1-4.9 4.7a4.5 4.5 0 0 0 .6 2.2.4.4 0 0 1 .1.3l-.5 1.5a.3.3 0 0 0 .4.4l1.4-.5a.4.4 0 0 1 .3 0 5 5 0 0 0 2.6.7c2.6 0 4.8-2.1 4.8-4.6s-2.2-4.7-4.8-4.7zM11 18.3v.3a.7.7 0 0 1-.7.7H5a.7.7 0 0 1-.6-.7v-.3c0-.8.9-1.3 1.8-1.7a.3.3 0 0 0 .1 0 .2.2 0 0 1 .2 0 2.2 2.2 0 0 0 1.2.3 2.2 2.2 0 0 0 1.2-.3.2.2 0 0 1 .2 0 .3.3 0 0 1 .1 0c.9.4 1.8.9 1.8 1.7z"
      },
      "ellipse": {
        "cx": "7.682",
        "cy": "14.462",
        "rx": "1.644",
        "ry": "1.819"
      }
    },
    sales_path: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.6 16.4l3.5-4.2c.1-.1.1-.3 0-.5l-3.5-4v-.2c0-.1.1-.2.2-.2h5c.2 0 .3 0 .3.1l3.6 4.4c.1.1.1.3 0 .5l-3.5 4.3c-.1.1-.2.2-.4.2H3.9c-.2 0-.3-.1-.3-.3v-.1zm7.6 0l3.4-4.2c.1-.1.1-.3 0-.5l-3.4-4v-.2c0-.1.1-.2.2-.2h5c.1 0 .2 0 .3.1l3.6 4.4c.1.1.1.3 0 .5l-3.6 4.3c0 .1-.2.2-.3.2h-5c-.1 0-.2-.1-.2-.3v-.1z"
      }
    },
    scan_card: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 7.2H6.2c-.8 0-1.4.6-1.4 1.4v6.8c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4V8.6c0-.8-.6-1.4-1.4-1.4zM6 12.7c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zm11.3 2.2c0 .2-.2.5-.5.5H7.7c-.3 0-.5-.3-.5-.5V9.1c0-.2.2-.5.5-.5h9.1c.3 0 .5.3.5.5v5.8zm-1.9-4.8H9.1c-.2 0-.5.2-.5.5v2.8c0 .3.3.5.5.5h6.3c.2 0 .4-.2.4-.5v-2.8c0-.3-.2-.5-.4-.5z"
      }
    },
    service_appointment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "rect": [{
        "x": "14.474",
        "y": "14.638",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "14.474",
        "y": "16.829",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "12.281",
        "y": "14.638",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "12.281",
        "y": "16.829",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "10.087",
        "y": "14.638",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "10.087",
        "y": "16.829",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }],
      "path": {
        "d": "M17.2 4.8H6.8a1.9 1.9 0 0 0-2 1.9v10.6a1.9 1.9 0 0 0 2 1.9h1.4a.9.9 0 0 1-.1-.4v-5.4a.3.3 0 0 1 .3-.3h9a.3.3 0 0 1 .3.3v5.4a.9.9 0 0 1 0 .4 1.9 1.9 0 0 0 1.5-1.9V6.7c0-1-.9-1.9-2-1.9zM7.4 8.7a.7.7 0 0 1-.7-.7v-.7a.7.7 0 0 1 .7-.6h3.4a.7.7 0 0 1 .6.6V8a.7.7 0 0 1-.6.7zm10.3 3.4a.3.3 0 0 1-.3.3h-9a.3.3 0 0 1-.3-.3v-.6a.9.9 0 0 1 .8-.9H10v-.4a.7.7 0 0 1 1.4 0v.4h3v-.4a.7.7 0 0 1 1.3 0v.4h1.1a.9.9 0 0 1 .9.9z",
        "fill-rule": "evenodd"
      }
    },
    service_contract: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 6.9l-3.2-3.1c-.1-.1-.1-.1-.2-.1-.2 0-.4.1-.4.3v2.6c0 .5.5.9 1 .9h2.5c.2 0 .4-.1.4-.3 0-.1 0-.2-.1-.3zm.1 2.5c0-.2-.2-.4-.5-.4h-3.4c-.8 0-1.4-.7-1.4-1.5V4.2c0-.3-.2-.5-.5-.5H6.1c-.8 0-1.4.6-1.4 1.4v11.5c0 .8.6 1.5 1.4 1.5H11s.5-.3.4-.7-.1-2.2 1.1-3.6 3.1-1.4 3.4-1.4c.3 0 .8-.1.8-.5V9.4zM6.4 6.7l1.1-.2h.1l.5-1.1c.1-.1.2-.1.2 0l.6 1.1 1.2.2c.1 0 .1.1.1.2l-.9.8v.1L9.5 9s-.1.1-.2.1l-1-.6h-.1l-1.1.6C7 9.1 6.9 9 7 9l.2-1.2s0-.1-.1-.1l-.8-.8c-.1-.1 0-.2.1-.2zm4.3 8c0 .3-.2.5-.5.5H7.1c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h3.1c.3 0 .5.2.5.4v.5zm2.6-2.9c0 .3-.2.5-.5.5H7.1c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h5.7c.3 0 .5.2.5.5v.4zm2.6 1.7c-1.9 0-3.4 1.5-3.4 3.4s1.5 3.5 3.4 3.5 3.4-1.6 3.4-3.5-1.5-3.4-3.4-3.4zm.6 3.7h-.3l-1.3 1.3c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.2-.1-.4 0-.6l1.3-1.3v-.3c0-.6.4-1.1 1-1.1h.3c.1 0 .1.1 0 .1l-.5.6c-.1 0-.1.1 0 .2l.4.4h.1l.6-.6h.1c0 .1.1.2.1.3-.1.6-.6 1.1-1.2 1z"
      }
    },
    service_crew: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.4 12.3h-.9v-1c0-1.5-.8-2.7-1.9-3.3v1.8c0 1-.8 1.8-1.7 1.8s-1.8-.8-1.8-1.8V8c-1.1.6-2 1.8-2 3.2v1.1h-.8c-.3 0-.5.2-.5.5s.2.5.5.5h9.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm-4.5-1.8c.4 0 .7-.3.7-.7V7.6H9.2v2.2c0 .4.3.7.7.7zM9.9 18.6c-2.2 0-3.9-1.9-3.9-4.3h1c0 1.8 1.3 3.3 2.9 3.3s2.9-1.5 2.9-3.3h.9c0 2.4-1.7 4.3-3.8 4.3zm5.8-11c.2 0 .5-.3.5-.5V5.5c-.2 0-.4-.1-.5-.1-.2 0-.3.1-.5.1v1.6c0 .2.2.5.5.5zm-.1 6.2v-1c1.1 0 1.9-.9 1.9-2.1h1c0 1.7-1.3 3.1-2.9 3.1zm3.1-5.1h-.5V8c0-.9-.5-1.8-1.3-2.2v1.3c0 .6-.6 1.2-1.2 1.2-.7 0-1.2-.6-1.2-1.2V5.7c-.8.4-1.4 1.3-1.4 2.2.5.5.8 1.1 1.1 1.8h4.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
      }
    },
    service_crew_member: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 10.9h-1.4V9.4c0-2-1.1-3.7-2.7-4.6v2.6c0 1.4-1.1 2.5-2.5 2.5S9.6 8.8 9.6 7.4V4.8c-1.7.8-2.9 2.6-2.9 4.6v1.5H5.4c-.3 0-.6.3-.6.7v.1c0 .4.2.7.6.7h13.1c.4 0 .7-.3.7-.7v-.1c0-.4-.3-.7-.6-.7zM12 8.4c.6 0 1-.4 1-1V4.3c-.3-.1-.6-.1-1-.1-.3 0-.6 0-1 .1v3.1c0 .6.5 1 1 1zM12 19.8c-3 0-5.5-2.7-5.5-6h1.4c0 2.5 1.8 4.6 4.1 4.6s4.1-2.1 4.1-4.6h1.4c0 3.3-2.5 6-5.5 6z"
      }
    },
    service_report: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.2 6h-.4a.2.2 0 0 0-.3.2v1a1.9 1.9 0 0 1-1.9 1.9H9.4a1.9 1.9 0 0 1-1.9-1.9v-1a.2.2 0 0 0-.3-.2h-.4a1.4 1.4 0 0 0-1.5 1.4v10.4a1.4 1.4 0 0 0 1.5 1.4h10.4a1.4 1.4 0 0 0 1.5-1.4V7.4A1.4 1.4 0 0 0 17.2 6zm-6.9 9.8a.5.5 0 0 1-.4.5h-.5a.5.5 0 0 1-.5-.5v-2.4a.5.5 0 0 1 .5-.4h.5a.5.5 0 0 1 .4.4zm2.4 0a.5.5 0 0 1-.5.5h-.4a.5.5 0 0 1-.5-.5v-4.5a.5.5 0 0 1 .5-.5h.4a.5.5 0 0 1 .5.5zm2.4 0a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.4-.5v-3.6a.5.5 0 0 1 .4-.4h.5a.5.5 0 0 1 .5.4zM9.4 7.7h5.2a.5.5 0 0 0 .5-.5v-1a1.4 1.4 0 0 0-1.4-1.4h-3.4a1.4 1.4 0 0 0-1.4 1.4v1a.5.5 0 0 0 .5.5z",
        "fill-rule": "evenodd"
      }
    },
    service_resource: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.2 4.8H6.8a1.9 1.9 0 0 0-2 1.9v10.6a1.9 1.9 0 0 0 2 1.9h2.6c.3-1.1 1.5-1.7 2.9-2.3 1-.4 1.2-.8 1.2-1.2s-.3-.8-.7-1.2a2.7 2.7 0 0 1-.9-2.1c0-1.6 1.1-3 2.9-3s2.9 1.4 2.9 3a2.9 2.9 0 0 1-1 2.1c-.3.4-.6.8-.6 1.2s.1.8 1.2 1.2a10 10 0 0 1 1.8 1 1.7 1.7 0 0 0 .1-.6V6.7c0-1-.9-1.9-2-1.9zM11.4 8a.7.7 0 0 1-.6.7H7.4a.7.7 0 0 1-.7-.7v-.7a.7.7 0 0 1 .7-.6h3.4a.7.7 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    service_territory: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M13.6 14.9a1.8 1.8 0 0 1-1.8-1.7 1.7 1.7 0 0 1 1.8-1.8 1.7 1.7 0 1 1 0 3.5zm3.6-10.1H6.8a1.9 1.9 0 0 0-2 1.9v10.6a1.9 1.9 0 0 0 2 1.9h5.8c-1.2-1.1-3.2-3.3-3.2-5.6a4.2 4.2 0 0 1 8.3 0c0 2.3-2.1 4.5-3.3 5.6h2.8a1.9 1.9 0 0 0 2-1.9V6.7c0-1-.9-1.9-2-1.9zM11.4 8a.7.7 0 0 1-.6.7H7.4a.7.7 0 0 1-.7-.7v-.7a.7.7 0 0 1 .7-.6h3.4a.7.7 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    service_territory_location: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M15.9 14.3c-.5 0-.9-.4-.9-1 0-.5.4-.9.9-.9s.9.4 1 .9c0 .5-.5 1-1 1zm-4.5 0c-.6 0-1-.4-1-1 0-.5.4-.9 1-.9s.9.4.9.9-.4 1-.9 1zm2.2 0c-.5 0-.9-.4-.9-1 0-.5.4-.9.9-.9s1 .4 1 .9-.4 1-1 1zm3.6-9.5H6.7c-1 0-1.9.9-1.9 1.9v10.7c0 1 .9 1.9 1.9 1.8h5.9c-1.2-1-3.3-3.3-3.3-5.6s1.9-4.1 4.2-4.1c2.3 0 4.1 1.8 4.1 4.1 0 2.4-2 4.6-3.2 5.6h2.8c1.1 0 1.9-.8 2-1.8V6.7c0-1-.9-1.9-2-1.9zM11.4 8c-.1.4-.4.7-.7.7H7.3c-.4 0-.7-.3-.7-.7v-.6c0-.4.3-.7.7-.7h3.4c.3 0 .7.3.7.7V8z"
      }
    },
    service_territory_member: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M10.3 10.1A1.7 1.7 0 0 1 12 8.4a1.7 1.7 0 1 1-1.7 1.7zM12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm.2 10.5a.3.3 0 0 1-.4 0c-.8-.5-3.3-2.8-3.3-5.1a3.5 3.5 0 0 1 7 0c0 2.3-2.5 4.5-3.3 5.1zm-6 .1h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    shipment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12.7 12.9v5.8c0 .2.1.3.3.3 0 0 .1 0 .1-.1 1.1-.6 4.6-2.6 4.6-2.6.5-.3.8-.7.8-1.3V9.8c0-.2-.1-.3-.3-.3 0 0-.1 0-.1.1L13 12.5c-.2 0-.3.2-.3.4zm-.5-1.7l5.2-2.9c.1 0 .2-.2.1-.3l-.1-.1c-1.1-.6-4.7-2.6-4.7-2.6-.4-.3-1-.3-1.4 0 0 0-3.6 1.9-4.7 2.6-.1.1-.2.2-.1.4h.1l5.2 2.9c.1.1.3.1.4 0zM11 12.5L5.9 9.6c-.1-.1-.3-.1-.4 0V15c0 .5.3 1 .8 1.3 0 0 3.5 2 4.6 2.6.1.1.3 0 .4-.1V12.9c0-.2-.1-.4-.3-.4z"
      }
    },
    skill: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M10.5 11.2a1.3 1.3 0 1 1 1.3-1.3 1.3 1.3 0 0 1-1.3 1.3zm8.1 2.2l-1.8-2.6v-.2a5.8 5.8 0 0 0-5.7-5.8 5.3 5.3 0 0 0-1.4.2 5.7 5.7 0 0 0-4.3 5.6 5.3 5.3 0 0 0 .8 3c1 1.4 1.7 2.6 1.3 4.2a1.1 1.1 0 0 0 .2 1 1.1 1.1 0 0 0 .9.4h4.7a1.1 1.1 0 0 0 1.1-.9 1.2 1.2 0 0 0 0-.3.6.6 0 0 1 .6-.5h.4a1.1 1.1 0 0 0 1.1-.8 9.9 9.9 0 0 0 .3-2.3h1.3a.7.7 0 0 0 .5-.4.7.7 0 0 0 0-.6zm-4.8-2l-.2.3a.5.5 0 0 1-.5.3.6.6 0 0 1-.1-.1l-.7-.2a2.8 2.8 0 0 1-.9.5l-.1.7a.5.5 0 0 1-.5.4h-.5a.5.5 0 0 1-.5-.4l-.1-.7a2.4 2.4 0 0 1-.9-.5l-.6.3a.6.6 0 0 1-.2 0 .5.5 0 0 1-.4-.2l-.3-.4a.5.5 0 0 1 .2-.6l.5-.5a2.4 2.4 0 0 1 0-.5 2.3 2.3 0 0 1 0-.5l-.5-.4a.5.5 0 0 1-.2-.7l.3-.3a.5.5 0 0 1 .4-.3.6.6 0 0 1 .2.1l.7.2a2.8 2.8 0 0 1 .8-.5l.1-.7a.5.5 0 0 1 .5-.4h.5a.5.5 0 0 1 .5.4l.1.7a2.7 2.7 0 0 1 .9.5l.7-.3a.6.6 0 0 1 .1 0 .5.5 0 0 1 .5.2l.2.4a.5.5 0 0 1-.1.6l-.6.5a2.3 2.3 0 0 1 .1.5 2.3 2.3 0 0 1-.1.5l.6.4a.5.5 0 0 1 .1.7z",
        "fill-rule": "evenodd"
      }
    },
    skill_entity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 13.4l-1.8-2.6v-.2c0-3.2-2.6-5.8-5.8-5.8-.4 0-.9 0-1.3.2-2.6.5-4.4 2.9-4.4 5.6 0 1.1.3 2.2.8 3 1.1 1.4 1.7 2.6 1.3 4.2-.1.3 0 .7.2 1 .2.3.6.4.9.4h4.7c.6 0 1.1-.4 1.2-.9V18c.1-.3.3-.5.6-.5h.3c.6 0 1-.3 1.2-.8.1-.5.3-1.3.3-2.3h1.3c.2 0 .4-.2.5-.4.1-.2.1-.5 0-.6zm-3.9-3.3c-.2.3-.5.5-1.1.5-2.9 0-3.2 2.1-3.2 3.2 0 .4-.3.8-.8.8h-.1c-.4 0-.7-.2-.8-.7-.1-.4-.4-.6-.7-.8-.2-.2-.4-.3-.5-.5-.3-.6-.5-1.2-.5-2.1C7 8.7 8.3 7 10 6.6c.4 0 .7-.1 1-.1 1.6 0 3.1 1 3.7 2.5.1 0 .3.6 0 1.1z"
      }
    },
    skill_requirement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 13.9a1.6 1.6 0 1 1 1.6-1.6 1.6 1.6 0 0 1-1.6 1.6zm7.4-2.7h-1.3V6.4a1.6 1.6 0 0 0-1.7-1.6H7.6a1.6 1.6 0 0 0-1.7 1.6v4.8H4.6a.8.8 0 0 0 0 1.6h1.3v4.8a1.6 1.6 0 0 0 1.7 1.6h8.8a1.6 1.6 0 0 0 1.7-1.6v-4.8h1.3a.8.8 0 0 0 0-1.6zM16 14.3l-.3.4a.6.6 0 0 1-.5.3.7.7 0 0 1-.2 0l-.8-.3a3.4 3.4 0 0 1-1.1.6l-.1.9a.6.6 0 0 1-.6.5h-.6a.6.6 0 0 1-.6-.5l-.1-.9a2.9 2.9 0 0 1-1.1-.6l-.8.3a.7.7 0 0 1-.2.1.6.6 0 0 1-.6-.3l-.2-.5a.6.6 0 0 1 .1-.8l.7-.6a3.2 3.2 0 0 1-.1-.6 3 3 0 0 1 .1-.6l-.7-.6a.6.6 0 0 1-.1-.8l.2-.5a.6.6 0 0 1 .6-.3.7.7 0 0 1 .2.1l.8.3a3.3 3.3 0 0 1 1.1-.7l.1-.8a.6.6 0 0 1 .6-.5h.6a.6.6 0 0 1 .6.5l.1.8a3.3 3.3 0 0 1 1.1.6l.8-.3a.7.7 0 0 1 .2 0 .6.6 0 0 1 .5.3l.3.5a.6.6 0 0 1-.1.8l-.7.5a3 3 0 0 1 .1.7 3 3 0 0 1-.1.6l.7.6a.6.6 0 0 1 .1.8z",
        "fill-rule": "evenodd"
      }
    },
    social: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.8 13.7c-1.2 0-2.1.8-2.4 1.9h-3.1c-.2 0-.3.1-.3.3V16.8c-.1.1.1.2.2.2h3.4c.4.9 1.2 1.5 2.2 1.5 1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4zm-6.4-2.8c-.3-.1-.6-.3-.8-.5-.1-.1-.3 0-.4.1l-1.7 3.2h-.3c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4c0-.7-.3-1.3-.7-1.8l1.6-3c.1-.2 0-.3-.1-.4zM12 9.8c.2 0 .5 0 .7-.1l1.6 3.1c.1.1.2.2.4.1.2-.2.5-.3.8-.4.1-.1.2-.2.1-.4l-1.7-3.2c.3-.4.5-.9.5-1.5C14.4 6.1 13.3 5 12 5S9.6 6.1 9.6 7.4s1.1 2.4 2.4 2.4z"
      }
    },
    solution: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.4 4.8C9.1 5.1 7.2 6.9 7 9.2c-.2 1.7.6 3.3 1.8 4.2.3.3.6.8.6 1.2 0 .7.5 1.3 1.2 1.3h2.8c.7 0 1.2-.6 1.2-1.3 0-.4.3-.9.6-1.2 1.1-.9 1.8-2.2 1.8-3.7 0-2.9-2.5-5.2-5.6-4.9zm2.8 12.5H9.8c-.2 0-.4.2-.4.5 0 .8.6 1.4 1.4 1.4h2.4c.8 0 1.4-.6 1.4-1.4 0-.3-.2-.5-.4-.5z"
      }
    },
    sossession: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.9 4.3c-4.2.1-7.6 3.6-7.6 7.8.1 4.2 3.6 7.6 7.8 7.6 4.2-.1 7.6-3.6 7.6-7.8-.1-4.2-3.6-7.6-7.8-7.6zm0 1c1.2 0 2.2.3 3.2.8L14 7.8c-.6-.3-1.3-.5-2-.5s-1.4.2-2 .5L8.9 6.1c.9-.5 1.9-.8 3-.8zM7.8 14l-1.7 1.1c-.5-.9-.8-1.9-.8-3 0-1.2.3-2.3.8-3.2l1.7 1c-.3.7-.5 1.4-.5 2.1s.2 1.4.5 2zm4.3 4.7c-1.2 0-2.2-.3-3.2-.8l1.1-1.7c.6.3 1.3.5 2 .5s1.4-.2 2-.5l1.1 1.7c-.9.5-1.9.8-3 .8zm-.1-3c-2 0-3.7-1.7-3.7-3.7S10 8.3 12 8.3s3.7 1.7 3.7 3.7-1.7 3.7-3.7 3.7zm4.2-1.7c.3-.6.5-1.3.5-2s-.2-1.4-.5-2l1.7-1.1c.5.9.8 1.9.8 3 0 1.2-.3 2.3-.8 3.2L16.2 14z"
      }
    },
    task: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.2 5.7l-.5-.5c-.2-.2-.4-.2-.5 0L7 8.4 5.7 7.1c-.1-.2-.3-.2-.5 0l-.5.5c-.1.1-.1.3 0 .5l1.8 1.8c.1.1.3.2.5.2s.4-.1.5-.2l3.7-3.7c.1-.1.1-.4 0-.5zm7.3 3.4h-6.3c-.2 0-.4-.2-.4-.5v-.9c0-.3.2-.5.4-.5h6.3c.2 0 .5.2.5.5v.9c0 .3-.3.5-.5.5zm0 4.3h-7.7c-.3 0-.5-.2-.5-.4v-1c0-.3.2-.5.5-.5h7.7c.2 0 .5.2.5.5v1c0 .2-.3.4-.5.4zm-10.6 0H7c-.3 0-.5-.2-.5-.4v-1c0-.3.2-.5.5-.5h.9c.3 0 .5.2.5.5v1c0 .2-.2.4-.5.4zm0 4.4H7c-.3 0-.5-.3-.5-.5v-1c0-.2.2-.5.5-.5h.9c.3 0 .5.3.5.5v1c0 .2-.2.5-.5.5zm10.6 0h-7.7c-.3 0-.5-.3-.5-.5v-1c0-.2.2-.5.5-.5h7.7c.2 0 .5.3.5.5v1c0 .2-.3.5-.5.5z"
      }
    },
    task2: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.2 17c-.3 0-.6-.1-.8-.3l-4.5-4.5c-.1-.2-.1-.5 0-.7l.9-.8c.2-.2.5-.2.7 0l3.7 3.7 7.3-7.3c.2-.2.5-.2.7 0l.9.9c.1.2.1.4 0 .6L11 16.7c-.2.2-.5.3-.8.3z"
      }
    },
    team_member: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M13.7 10.6h-2.9c-.8 0-1.4.6-1.4 1.4v2.2c0 .2.1.5.2.6.2.2.5.3.7.3v2.2c0 .8.7 1.4 1.5 1.4h.9c.8 0 1.5-.6 1.5-1.4v-2.2c.2 0 .5-.1.6-.3.2-.1.3-.4.3-.6V12c0-.8-.6-1.4-1.4-1.4z"
      }, {
        "d": "M8.8 16c-.1 0-.1-.1-.2-.1-.4-.5-.7-1.1-.7-1.7V12c0-.8.3-1.5.8-2 .2-.1 0-.4-.2-.4H6.2c-.8 0-1.4.6-1.4 1.4v2.2c0 .3.1.5.3.7.2.1.4.3.7.3v2.1c0 .8.6 1.5 1.4 1.5h1c.2 0 .4-.1.5-.2.1 0 .2-.1.2-.2v-1.2c0-.1 0-.1-.1-.2z"
      }, {
        "d": "M18.2 9.6h-2.3c-.2 0-.3.2-.1.4.5.5.8 1.2.8 2v2.2c0 .6-.3 1.2-.7 1.7-.1 0-.1.1-.2.1-.1.1-.1.1-.1.2v1.2c0 .1 0 .2.1.2.2.1.4.2.6.2h1c.8 0 1.4-.7 1.4-1.5v-2.1c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7V11c0-.8-.7-1.4-1.5-1.4z"
      }],
      "circle": [{
        "cx": "12.24",
        "cy": "7.92",
        "r": "1.68"
      }, {
        "cx": "7.68",
        "cy": "6.96",
        "r": "1.68"
      }, {
        "cx": "16.8",
        "cy": "6.96",
        "r": "1.68"
      }]
    },
    template: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.7 4.8H6.3c-.8 0-1.5.7-1.5 1.5v11.4c0 .8.7 1.5 1.5 1.5h11.4c.8 0 1.5-.7 1.5-1.5V6.3c0-.8-.7-1.5-1.5-1.5zm-7.5 11.8c0 .2-.2.3-.4.3H7.3c-.2 0-.3-.2-.3-.4v-4.8c0-.2.2-.3.3-.3h2.5c.2 0 .4.2.4.4v4.8zm6.8 0c0 .2-.2.4-.4.4H12c-.2 0-.4-.2-.4-.4v-4.9c0-.2.2-.3.4-.3h4.7c.1 0 .3.2.3.4v4.8zm0-7c0 .2-.2.3-.4.3H7.3c-.2 0-.3-.2-.3-.4V7.4c0-.2.2-.4.3-.4h9.4c.2 0 .3.2.3.4v2.2z"
      }
    },
    thanks: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 8.4h-2.1c.6-.9.5-2.2-.2-3-.4-.4-1-.6-1.6-.6-.6 0-1.2.3-1.7.8-.1.1-.1.2-.2.3-.1-.1-.1-.2-.2-.3-.5-.5-1.1-.8-1.7-.8-.6 0-1.1.2-1.6.6-.7.8-.7 2.1-.1 3H6.2c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5h13.4c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4zm-6.5 0c-.5 0-1.2-.2-1.7-.6-.3-.4-.4-1 0-1.3.1-.2.3-.2.5-.2s.4.1.6.3c.4.4.6 1.2.6 1.7v.1zm3.1-.6c-.5.4-1.2.6-1.7.6v-.1c0-.5.2-1.3.6-1.7.2-.2.4-.4.6-.4.2 0 .4.1.5.2.3.4.3 1 0 1.4zm3.4 4.9h-5.1v6.5h4.1c.8 0 1.4-.6 1.4-1.4v-4.6c0-.3-.2-.5-.4-.5zm-12 .5v4.6c0 .8.6 1.4 1.4 1.4h4.1v-6.5H6.2c-.2 0-.4.2-.4.5z"
      }
    },
    thanks_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M17.8 8.4h-2.1c.6-.9.5-2.2-.2-3-.4-.4-1-.6-1.6-.6-.6 0-1.2.3-1.7.8-.1.1-.1.2-.2.3-.1-.1-.1-.2-.2-.3-.5-.5-1.1-.8-1.7-.8-.6 0-1.1.2-1.6.6-.7.8-.7 2.1-.1 3H6.2c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5h13.4c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4zm-6.5 0c-.5 0-1.2-.2-1.7-.6-.3-.4-.4-1 0-1.3.1-.2.3-.2.5-.2s.4.1.6.3c.4.4.6 1.2.6 1.7v.1zm3.1-.6c-.5.4-1.2.6-1.7.6v-.1c0-.5.2-1.3.6-1.7.2-.2.4-.4.6-.4.2 0 .4.1.5.2.3.4.3 1 0 1.4zm3.4 4.9h-5.1v6.5h4.1c.8 0 1.4-.6 1.4-1.4v-4.6c0-.3-.2-.5-.4-.5zm-12 .5v4.6c0 .8.6 1.4 1.4 1.4h4.1v-6.5H6.2c-.2 0-.4.2-.4.5z"
      }
    },
    timesheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17 4.8H7c-1 0-1.9.8-1.9 1.9v10.6c0 1 .9 1.9 1.9 1.9h10c1 0 1.9-.9 1.9-1.9V6.7c0-1.1-.9-1.9-1.9-1.9zm-.6 11.3c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.6c0-.4.3-.7.6-.7h7.5c.4 0 .7.3.7.7v.6zm0-3.8c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.6c0-.3.3-.6.6-.6h7.5c.4 0 .7.3.7.6v.6zm0-3.7c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.7c0-.3.3-.6.6-.6h7.5c.4 0 .7.3.7.6v.7z"
      }
    },
    timesheet_entry: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17 4.8H7c-1 0-1.9.8-1.9 1.9v10.6c0 1 .9 1.9 1.9 1.9h10c1 0 1.9-.9 1.9-1.9V6.7c0-1.1-.9-1.9-1.9-1.9zm-.6 11.3c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.6c0-.4.3-.7.6-.7h7.5c.4 0 .7.3.7.7v.6zM9.8 12l.4-.3c0-.1.2-.1.3 0l.9.8 2.1-2.1c.1-.1.3-.1.3 0l.4.3c.1.1.1.3 0 .3l-2.5 2.6c-.1.1-.2.1-.3.1-.1 0-.3 0-.4-.1l-1.2-1.2c-.1-.2-.1-.3 0-.4zm6.6-3.4c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.7c0-.3.3-.6.6-.6h7.5c.4 0 .7.3.7.6v.7z"
      }
    },
    timeslot: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17 4.8H7a1.9 1.9 0 0 0-1.9 1.9v10.6A1.9 1.9 0 0 0 7 19.2h10a1.9 1.9 0 0 0 1.9-1.9V6.7A1.9 1.9 0 0 0 17 4.8zM7.6 7.9a.6.6 0 0 1 .7-.6h3.2a.6.6 0 0 1 .6.6v.6a.6.6 0 0 1-.6.7H8.3a.6.6 0 0 1-.7-.7zm8.7 8.2a.6.6 0 0 1-.6.6h-3.2a.6.6 0 0 1-.6-.6v-.6a.6.6 0 0 1 .6-.7h3.2a.6.6 0 0 1 .6.7zm.1-3a.7.7 0 0 1-.6.6H8.3a.6.6 0 0 1-.7-.6v-2.2a.6.6 0 0 1 .7-.6h7.5a.6.6 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    today: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 13c-3.2 0-5.8-2.6-5.8-5.8S8.8 6.2 12 6.2s5.8 2.6 5.8 5.8-2.6 5.8-5.8 5.8zm.7-6.1V8.6c0-.2-.2-.4-.5-.4h-.4c-.3 0-.5.2-.5.4V12c0 .2.1.4.2.5l2.3 2.3c.2.2.5.2.7 0l.3-.3c.2-.2.2-.5 0-.7l-2.1-2.1z"
      }
    },
    topic: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.7 8.9c.1.2.2.3.4.4l.5.1c.1 0 .2 0 .3-.1l1.1-2c.3-.4.1-.6-.4-.3l-1.9 1.1c-.1.1-.2.2-.1.3l.1.5zm-6.6.4c.1.1.2.1.3.1l.5-.1c.2-.1.3-.2.4-.4l.1-.5c0-.1 0-.2-.1-.3L7.3 7c-.4-.3-.6-.1-.3.4l1.1 1.9zm7.8 5.4c-.1-.1-.2-.1-.3-.1l-.5.1c-.2.1-.3.2-.4.4l-.1.5c0 .1 0 .2.1.3l2 1.1c.4.3.6.1.3-.4l-1.1-1.9zm-6.6.4c-.1-.2-.2-.3-.4-.4l-.5-.1c-.1 0-.2 0-.3.1l-1.1 2c-.3.4-.1.6.4.3l1.9-1.1c.1-.1.2-.2.1-.3l-.1-.5zm9.5-3.3l-4.9-1.4c-.2 0-.3-.1-.3-.3l-1.4-4.9c-.1-.5-.3-.5-.5 0l-1.3 4.9c0 .2-.2.3-.3.3l-4.9 1.4c-.5.1-.5.3 0 .5l4.9 1.3c.2 0 .3.2.3.3l1.4 4.9c.1.5.3.5.5 0l1.3-4.9c0-.2.2-.3.3-.3l4.9-1.4c.5-.1.5-.3 0-.4zM12 13.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2z"
      }
    },
    topic2: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 8.2h-1.9l.8-3.1V5c0-.1-.1-.2-.3-.2h-1.5c-.1 0-.2.1-.2.2l-.8 3.2h-3.8l.8-3.1V5c0-.1-.1-.2-.2-.2h-1.5c-.2 0-.3.1-.3.2l-.8 3.2H7c-.2 0-.2.1-.3.2l-.4 1.4v.1c0 .1.1.2.3.2h2l-1 3.7h-2c-.1 0-.2 0-.2.1L5 15.4c0 .1.1.2.2.2h1.9l-.8 3.2v.1c0 .1.1.2.3.2h1.5c.1 0 .2-.1.2-.2l.8-3.3h3.8l-.8 3.2c0 .2.1.3.2.3h1.5c.2 0 .3-.1.3-.2l.8-3.3H17c.1 0 .2-.1.3-.2l.3-1.4v-.1c0-.1-.1-.2-.2-.2h-2l1-3.7h2c.1 0 .2 0 .2-.2l.4-1.4c0-.1-.1-.2-.2-.2zm-5.4 5.6H9.6l1-3.6h3.8l-1 3.6z"
      }
    },
    unmatched: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.8 11.2c-.1-.1-.2-.2-.3-.2h-7c-.1 0-.2.1-.3.2v1.6c.1.1.2.2.3.2h7c.1 0 .2-.1.3-.2V12v-.8zM12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 12.5c-2.9 0-5.3-2.4-5.3-5.3S9.1 6.7 12 6.7s5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3z"
      }
    },
    user: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8.9 0 1.8-.3 2.6-.8.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
      },
      "ellipse": {
        "cx": "12",
        "cy": "8.76",
        "rx": "3.576",
        "ry": "3.96"
      }
    },
    work_order: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.6 12.5c-.8.4-1.2 1.2-1.2 1.3-.1.2-.2.2-.2.2H9.9c-.1 0-.2-.1-.2-.2-.4-.8-1.2-1.4-2.2-1.4-.9 0-1.6.4-2 1.2-.1.1-.2.1-.3 0-.3-.2-.4-.5-.4-.9 0 0-.1-2.7.8-4.2.2-.2.3-.3.5-.3h9.1c.1 0 .2 0 .3.1 0 0 1 1.5 1.2 1.6.1.2.2.3.5.3.2.1 2 .7 2 .7v1.8c0 .4-.1.7-.3.9-.1.1-.2 0-.3-.1-.4-.7-1.1-1.2-2-1.2-.4 0-.7.1-1 .2"
      },
      "ellipse": [{
        "cx": "16.56",
        "cy": "14.664",
        "rx": "1.176",
        "ry": "1.176"
      }, {
        "cx": "7.56",
        "cy": "14.664",
        "rx": "1.176",
        "ry": "1.176"
      }]
    },
    work_order_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.4 7.7h5.2c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5zM17.3 6h-.5c-.1 0-.2.1-.2.2v1c0 1.1-.9 1.9-2 1.9H9.4c-1.1 0-2-.8-2-1.9v-1c0-.1-.1-.2-.2-.2h-.5c-.8 0-1.4.6-1.4 1.4v10.4c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V7.4c0-.8-.6-1.4-1.4-1.4zM16 11.8l-4.6 4.6c-.1.1-.2.2-.4.2s-.3-.1-.5-.2L8 13.8c-.2-.1-.2-.3 0-.4l.5-.5c.1-.1.2-.1.4 0L11 15l4.1-4.1c.1-.1.3-.1.4 0l.5.5c.1.1.1.3 0 .4z"
      }
    },
    work_type: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M18.2 7L16 4.9a.3.3 0 0 0-.2-.1.3.3 0 0 0-.3.3v1.6a.9.9 0 0 0 .9.9H18a.3.3 0 0 0 .3-.3.4.4 0 0 0-.1-.3zM7.1 15V7.6A1.4 1.4 0 0 0 5.7 9v8.8a1.4 1.4 0 0 0 1.4 1.4h7a1.4 1.4 0 0 0 1.4-1.4H9.9c-1.5 0-2.8 0-2.8-2.8zm10.7-6h-2.3a1.4 1.4 0 0 1-1.4-1.4V5.3a.4.4 0 0 0-.5-.5H9.9a1.4 1.4 0 0 0-1.4 1.4V15a1.4 1.4 0 0 0 1.4 1.4h7a1.4 1.4 0 0 0 1.4-1.4V9.5a.5.5 0 0 0-.5-.5zM12 14.9a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.6h1.2a.6.6 0 0 1 .6.6zm0-3.3a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.5h1.2a.6.6 0 0 1 .6.5zm3.3 3.3a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.6h1.2a.6.6 0 0 1 .6.6zm0-3.3a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.6h1.2a.6.6 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    viewBox: '0 0 24 24'
  };
}

export default icons;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@salesforce/design-system-react/module/icons/standard/index.js
// module id = 192
// module chunks = 0